var items = {
  "block.minecraft.acacia_button": "Botão de Acácia",
  "block.minecraft.acacia_door": "Porta de Acácia",
  "block.minecraft.acacia_fence": "Cerca de Acácia",
  "block.minecraft.acacia_fence_gate": "Portão de Acácia",
  "block.minecraft.acacia_hanging_sign": "Tabuleta Pendurada de Acácia",
  "block.minecraft.acacia_leaves": "Folhas de Acácia",
  "block.minecraft.acacia_log": "Tronco de Acácia",
  "block.minecraft.acacia_planks": "Tábuas de Acácia",
  "block.minecraft.acacia_pressure_plate": "Placa de Pressão de Acácia",
  "block.minecraft.acacia_sapling": "Rebento de Acácia",
  "block.minecraft.acacia_shelf": "Estante de Acácia",
  "block.minecraft.acacia_sign": "Tabuleta de Acácia",
  "block.minecraft.acacia_slab": "Degrau de Acácia",
  "block.minecraft.acacia_stairs": "Escadas de Acácia",
  "block.minecraft.acacia_trapdoor": "Alçapão de Acácia",
  "block.minecraft.acacia_wall_hanging_sign": "Tabuleta Pendurada de Acácia de Parede",
  "block.minecraft.acacia_wall_sign": "Tabuleta de Acácia de Parede",
  "block.minecraft.acacia_wood": "Madeira de Acácia",
  "block.minecraft.activator_rail": "Carril Ativador",
  "block.minecraft.air": "Ar",
  "block.minecraft.allium": "Alho-Porro",
  "block.minecraft.amethyst_block": "Bloco de Ametista",
  "block.minecraft.amethyst_cluster": "Agregado de Ametista",
  "block.minecraft.ancient_debris": "Detritos Ancestrais",
  "block.minecraft.andesite": "Andesito",
  "block.minecraft.andesite_slab": "Degrau de Andesito",
  "block.minecraft.andesite_stairs": "Escadas de Andesito",
  "block.minecraft.andesite_wall": "Muro de Andesito",
  "block.minecraft.anvil": "Bigorna",
  "block.minecraft.attached_melon_stem": "Caule com Melancia Unido",
  "block.minecraft.attached_pumpkin_stem": "Caule com Abóbora Unido",
  "block.minecraft.azalea": "Azálea",
  "block.minecraft.azalea_leaves": "Folhas de Azálea",
  "block.minecraft.azure_bluet": "Jasmim",
  "block.minecraft.bamboo": "Bambu",
  "block.minecraft.bamboo_block": "Bloco de Bambu",
  "block.minecraft.bamboo_button": "Botão de Bambu",
  "block.minecraft.bamboo_door": "Porta de Bambu",
  "block.minecraft.bamboo_fence": "Cerca de Bambu",
  "block.minecraft.bamboo_fence_gate": "Portão de Bambu",
  "block.minecraft.bamboo_hanging_sign": "Tabuleta Pendurada de Bambu",
  "block.minecraft.bamboo_mosaic": "Mosaico de Bambu",
  "block.minecraft.bamboo_mosaic_slab": "Degrau de Mosaico de Bambu",
  "block.minecraft.bamboo_mosaic_stairs": "Escadas de Mosaico de Bambu",
  "block.minecraft.bamboo_planks": "Tábuas de Bambu",
  "block.minecraft.bamboo_pressure_plate": "Placa de Pressão de Bambu",
  "block.minecraft.bamboo_sapling": "Rebento de Bambu",
  "block.minecraft.bamboo_shelf": "Estante de Bambu",
  "block.minecraft.bamboo_sign": "Tabuleta de Bambu",
  "block.minecraft.bamboo_slab": "Degrau de bambu",
  "block.minecraft.bamboo_stairs": "Escadas de Bambu",
  "block.minecraft.bamboo_trapdoor": "Alçapão de Bambu",
  "block.minecraft.bamboo_wall_hanging_sign": "Tabuleta Pendurada de Bambu de Parede",
  "block.minecraft.bamboo_wall_sign": "Tabuleta de Bambu de Parede",
  "block.minecraft.banner.base.black": "Campo Preto",
  "block.minecraft.banner.base.blue": "Campo Azul",
  "block.minecraft.banner.base.brown": "Campo Castanho",
  "block.minecraft.banner.base.cyan": "Campo Cíano",
  "block.minecraft.banner.base.gray": "Campo Cinzento",
  "block.minecraft.banner.base.green": "Campo Verde",
  "block.minecraft.banner.base.light_blue": "Campo Azul-Claro",
  "block.minecraft.banner.base.light_gray": "Campo Cinzento-Claro",
  "block.minecraft.banner.base.lime": "Campo Verde-Lima",
  "block.minecraft.banner.base.magenta": "Campo Magenta",
  "block.minecraft.banner.base.orange": "Campo Laranja",
  "block.minecraft.banner.base.pink": "Campo Rosa",
  "block.minecraft.banner.base.purple": "Campo Roxo",
  "block.minecraft.banner.base.red": "Campo Vermelho",
  "block.minecraft.banner.base.white": "Campo Branco",
  "block.minecraft.banner.base.yellow": "Campo Amarelo",
  "block.minecraft.banner.border.black": "Bordadura Preta",
  "block.minecraft.banner.border.blue": "Bordadura Azul",
  "block.minecraft.banner.border.brown": "Bordadura Castanha",
  "block.minecraft.banner.border.cyan": "Bordadura Cíano",
  "block.minecraft.banner.border.gray": "Bordadura Cinzenta",
  "block.minecraft.banner.border.green": "Bordadura Verde",
  "block.minecraft.banner.border.light_blue": "Bordadura Azul-Clara",
  "block.minecraft.banner.border.light_gray": "Bordadura Cinzento-Clara",
  "block.minecraft.banner.border.lime": "Bordadura Verde-Lima",
  "block.minecraft.banner.border.magenta": "Bordadura Magenta",
  "block.minecraft.banner.border.orange": "Bordadura Laranja",
  "block.minecraft.banner.border.pink": "Bordadura Rosa",
  "block.minecraft.banner.border.purple": "Bordadura Roxa",
  "block.minecraft.banner.border.red": "Bordadura Vermelha",
  "block.minecraft.banner.border.white": "Bordadura Branca",
  "block.minecraft.banner.border.yellow": "Bordadura Amarela",
  "block.minecraft.banner.bricks.black": "Alvenaria Preta",
  "block.minecraft.banner.bricks.blue": "Alvenaria Azul",
  "block.minecraft.banner.bricks.brown": "Alvenaria Castanha",
  "block.minecraft.banner.bricks.cyan": "Alvenaria Cíano",
  "block.minecraft.banner.bricks.gray": "Alvenaria Cinzenta",
  "block.minecraft.banner.bricks.green": "Alvenaria Verde",
  "block.minecraft.banner.bricks.light_blue": "Alvenaria Azul-Clara",
  "block.minecraft.banner.bricks.light_gray": "Alvenaria Cinzento-Clara",
  "block.minecraft.banner.bricks.lime": "Alvenaria Verde-Lima",
  "block.minecraft.banner.bricks.magenta": "Alvenaria Magenta",
  "block.minecraft.banner.bricks.orange": "Alvenaria Laranja",
  "block.minecraft.banner.bricks.pink": "Alvenaria Rosa",
  "block.minecraft.banner.bricks.purple": "Alvenaria Roxa",
  "block.minecraft.banner.bricks.red": "Alvenaria Vermelha",
  "block.minecraft.banner.bricks.white": "Alvenaria Branca",
  "block.minecraft.banner.bricks.yellow": "Alvenaria Amarela",
  "block.minecraft.banner.circle.black": "Besante Preto",
  "block.minecraft.banner.circle.blue": "Besante Azul",
  "block.minecraft.banner.circle.brown": "Besante Castanho",
  "block.minecraft.banner.circle.cyan": "Besante Cíano",
  "block.minecraft.banner.circle.gray": "Besante Cinzento",
  "block.minecraft.banner.circle.green": "Besante Verde",
  "block.minecraft.banner.circle.light_blue": "Besante Azul-Claro",
  "block.minecraft.banner.circle.light_gray": "Besante Cinzento-Claro",
  "block.minecraft.banner.circle.lime": "Besante Verde-Lima",
  "block.minecraft.banner.circle.magenta": "Besante Magenta",
  "block.minecraft.banner.circle.orange": "Besante Laranja",
  "block.minecraft.banner.circle.pink": "Besante Rosa",
  "block.minecraft.banner.circle.purple": "Besante Roxo",
  "block.minecraft.banner.circle.red": "Besante Vermelho",
  "block.minecraft.banner.circle.white": "Besante Branco",
  "block.minecraft.banner.circle.yellow": "Besante Amarelo",
  "block.minecraft.banner.creeper.black": "Figura de Creeper Preto",
  "block.minecraft.banner.creeper.blue": "Figura de Creeper Azul",
  "block.minecraft.banner.creeper.brown": "Figura de Creeper Castanho",
  "block.minecraft.banner.creeper.cyan": "Figura de Creeper Cíano",
  "block.minecraft.banner.creeper.gray": "Figura de Creeper Cinzento",
  "block.minecraft.banner.creeper.green": "Figura de Creeper Verde",
  "block.minecraft.banner.creeper.light_blue": "Figura de Creeper Azul-Claro",
  "block.minecraft.banner.creeper.light_gray": "Figura de Creeper Cinzento-Claro",
  "block.minecraft.banner.creeper.lime": "Figura de Creeper Verde-Lima",
  "block.minecraft.banner.creeper.magenta": "Figura de Creeper Magenta",
  "block.minecraft.banner.creeper.orange": "Figura de Creeper Laranja",
  "block.minecraft.banner.creeper.pink": "Figura de Creeper Rosa",
  "block.minecraft.banner.creeper.purple": "Figura de Creeper Roxo",
  "block.minecraft.banner.creeper.red": "Figura de Creeper Vermelho",
  "block.minecraft.banner.creeper.white": "Figura de Creeper Branco",
  "block.minecraft.banner.creeper.yellow": "Figura de Creeper Amarelo",
  "block.minecraft.banner.cross.black": "Aspa Preta",
  "block.minecraft.banner.cross.blue": "Aspa Azul",
  "block.minecraft.banner.cross.brown": "Aspa Castanha",
  "block.minecraft.banner.cross.cyan": "Aspa Cíano",
  "block.minecraft.banner.cross.gray": "Aspa Cinzenta",
  "block.minecraft.banner.cross.green": "Aspa Verde",
  "block.minecraft.banner.cross.light_blue": "Aspa Azul-Clara",
  "block.minecraft.banner.cross.light_gray": "Aspa Cinzento-Clara",
  "block.minecraft.banner.cross.lime": "Aspa Verde-Lima",
  "block.minecraft.banner.cross.magenta": "Aspa Magenta",
  "block.minecraft.banner.cross.orange": "Aspa Laranja",
  "block.minecraft.banner.cross.pink": "Aspa Rosa",
  "block.minecraft.banner.cross.purple": "Aspa Roxa",
  "block.minecraft.banner.cross.red": "Aspa Vermelha",
  "block.minecraft.banner.cross.white": "Aspa Branca",
  "block.minecraft.banner.cross.yellow": "Aspa Amarela",
  "block.minecraft.banner.curly_border.black": "Bordadura Dentada Preta",
  "block.minecraft.banner.curly_border.blue": "Bordadura Dentada Azul",
  "block.minecraft.banner.curly_border.brown": "Bordadura Dentada Castanha",
  "block.minecraft.banner.curly_border.cyan": "Bordadura Dentada Cíano",
  "block.minecraft.banner.curly_border.gray": "Bordadura Dentada Cinzenta",
  "block.minecraft.banner.curly_border.green": "Bordadura Dentada Verde",
  "block.minecraft.banner.curly_border.light_blue": "Bordadura Dentada Azul-Clara",
  "block.minecraft.banner.curly_border.light_gray": "Bordadura Dentada Cinzento-Clara",
  "block.minecraft.banner.curly_border.lime": "Bordadura Dentada Verde-Lima",
  "block.minecraft.banner.curly_border.magenta": "Bordadura Dentada Magenta",
  "block.minecraft.banner.curly_border.orange": "Bordadura Dentada Laranja",
  "block.minecraft.banner.curly_border.pink": "Bordadura Dentada Rosa",
  "block.minecraft.banner.curly_border.purple": "Bordadura Dentada Roxa",
  "block.minecraft.banner.curly_border.red": "Bordadura Dentada Vermelha",
  "block.minecraft.banner.curly_border.white": "Bordadura Dentada Branca",
  "block.minecraft.banner.curly_border.yellow": "Bordadura Dentada Amarela",
  "block.minecraft.banner.diagonal_left.black": "Talhado Preto",
  "block.minecraft.banner.diagonal_left.blue": "Talhado Azul",
  "block.minecraft.banner.diagonal_left.brown": "Talhado Castanho",
  "block.minecraft.banner.diagonal_left.cyan": "Talhado Cíano",
  "block.minecraft.banner.diagonal_left.gray": "Talhado Cinzento",
  "block.minecraft.banner.diagonal_left.green": "Talhado Verde",
  "block.minecraft.banner.diagonal_left.light_blue": "Talhado Azul-Claro",
  "block.minecraft.banner.diagonal_left.light_gray": "Talhado Cinzento-Claro",
  "block.minecraft.banner.diagonal_left.lime": "Talhado Verde-Lima",
  "block.minecraft.banner.diagonal_left.magenta": "Talhado Magenta",
  "block.minecraft.banner.diagonal_left.orange": "Talhado Laranja",
  "block.minecraft.banner.diagonal_left.pink": "Talhado Rosa",
  "block.minecraft.banner.diagonal_left.purple": "Talhado Roxo",
  "block.minecraft.banner.diagonal_left.red": "Talhado Vermelho",
  "block.minecraft.banner.diagonal_left.white": "Talhado Branco",
  "block.minecraft.banner.diagonal_left.yellow": "Talhado Amarelo",
  "block.minecraft.banner.diagonal_right.black": "Fendido Preto",
  "block.minecraft.banner.diagonal_right.blue": "Fendido Azul",
  "block.minecraft.banner.diagonal_right.brown": "Fendido Castanho",
  "block.minecraft.banner.diagonal_right.cyan": "Fendido Cíano",
  "block.minecraft.banner.diagonal_right.gray": "Fendido Cinzento",
  "block.minecraft.banner.diagonal_right.green": "Fendido Verde",
  "block.minecraft.banner.diagonal_right.light_blue": "Fendido Azul-Claro",
  "block.minecraft.banner.diagonal_right.light_gray": "Fendido Cinzento-Claro",
  "block.minecraft.banner.diagonal_right.lime": "Fendido Verde-Lima",
  "block.minecraft.banner.diagonal_right.magenta": "Fendido Magenta",
  "block.minecraft.banner.diagonal_right.orange": "Fendido Laranja",
  "block.minecraft.banner.diagonal_right.pink": "Fendido Rosa",
  "block.minecraft.banner.diagonal_right.purple": "Fendido Roxo",
  "block.minecraft.banner.diagonal_right.red": "Fendido Vermelho",
  "block.minecraft.banner.diagonal_right.white": "Fendido Branco",
  "block.minecraft.banner.diagonal_right.yellow": "Fendido Amarelo",
  "block.minecraft.banner.diagonal_up_left.black": "Fendido Preto Invertido",
  "block.minecraft.banner.diagonal_up_left.blue": "Fendido Azul Invertido",
  "block.minecraft.banner.diagonal_up_left.brown": "Fendido Castanho Invertido",
  "block.minecraft.banner.diagonal_up_left.cyan": "Fendido Cíano Invertido",
  "block.minecraft.banner.diagonal_up_left.gray": "Fendido Cinzento Invertido",
  "block.minecraft.banner.diagonal_up_left.green": "Fendido Verde Invertido",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Fendido Azul-Claro Invertido",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Fendido Cinzento-Claro Invertido",
  "block.minecraft.banner.diagonal_up_left.lime": "Fendido Verde-Lima Invertido",
  "block.minecraft.banner.diagonal_up_left.magenta": "Fendido Magenta Invertido",
  "block.minecraft.banner.diagonal_up_left.orange": "Fendido Laranja Invertido",
  "block.minecraft.banner.diagonal_up_left.pink": "Fendido Rosa Invertido",
  "block.minecraft.banner.diagonal_up_left.purple": "Fendido Roxo Invertido",
  "block.minecraft.banner.diagonal_up_left.red": "Fendido Vermelho Invertido",
  "block.minecraft.banner.diagonal_up_left.white": "Fendido Branco Invertido",
  "block.minecraft.banner.diagonal_up_left.yellow": "Fendido Amarelo Invertido",
  "block.minecraft.banner.diagonal_up_right.black": "Talhado Preto Invertido",
  "block.minecraft.banner.diagonal_up_right.blue": "Talhado Azul Invertido",
  "block.minecraft.banner.diagonal_up_right.brown": "Talhado Castanho Invertido",
  "block.minecraft.banner.diagonal_up_right.cyan": "Talhado Cíano Invertido",
  "block.minecraft.banner.diagonal_up_right.gray": "Talhado Cinzento Invertido",
  "block.minecraft.banner.diagonal_up_right.green": "Talhado Verde Invertido",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Talhado Azul-Claro Invertido",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Talhado Cinzento-Claro Invertido",
  "block.minecraft.banner.diagonal_up_right.lime": "Talhado Verde-Lima Invertido",
  "block.minecraft.banner.diagonal_up_right.magenta": "Talhado Magenta Invertido",
  "block.minecraft.banner.diagonal_up_right.orange": "Talhado Laranja Invertido",
  "block.minecraft.banner.diagonal_up_right.pink": "Talhado Rosa Invertido",
  "block.minecraft.banner.diagonal_up_right.purple": "Talhado Roxo Invertido",
  "block.minecraft.banner.diagonal_up_right.red": "Talhado Vermelho Invertido",
  "block.minecraft.banner.diagonal_up_right.white": "Talhado Branco Invertido",
  "block.minecraft.banner.diagonal_up_right.yellow": "Talhado Amarelo Invertido",
  "block.minecraft.banner.flow.black": "Espiral Preta",
  "block.minecraft.banner.flow.blue": "Espiral Azul",
  "block.minecraft.banner.flow.brown": "Espiral Castanha",
  "block.minecraft.banner.flow.cyan": "Espiral Cíano",
  "block.minecraft.banner.flow.gray": "Espiral Cinzenta",
  "block.minecraft.banner.flow.green": "Espiral Verde",
  "block.minecraft.banner.flow.light_blue": "Espiral Azul-Clara",
  "block.minecraft.banner.flow.light_gray": "Espiral Cinzento-Clara",
  "block.minecraft.banner.flow.lime": "Espiral Verde-Lima",
  "block.minecraft.banner.flow.magenta": "Espiral Magenta",
  "block.minecraft.banner.flow.orange": "Espiral Laranja",
  "block.minecraft.banner.flow.pink": "Espiral Rosa",
  "block.minecraft.banner.flow.purple": "Espiral Roxa",
  "block.minecraft.banner.flow.red": "Espiral Vermelha",
  "block.minecraft.banner.flow.white": "Espiral Branca",
  "block.minecraft.banner.flow.yellow": "Espiral Amarela",
  "block.minecraft.banner.flower.black": "Figura de Flor Preta",
  "block.minecraft.banner.flower.blue": "Figura de Flor Azul",
  "block.minecraft.banner.flower.brown": "Figura de Flor Castanha",
  "block.minecraft.banner.flower.cyan": "Figura de Flor Cíano",
  "block.minecraft.banner.flower.gray": "Figura de Flor Cinzenta",
  "block.minecraft.banner.flower.green": "Figura de Flor Verde",
  "block.minecraft.banner.flower.light_blue": "Figura de Flor Azul-Clara",
  "block.minecraft.banner.flower.light_gray": "Figura de Flor Cinzento-Clara",
  "block.minecraft.banner.flower.lime": "Figura de Flor Verde-Lima",
  "block.minecraft.banner.flower.magenta": "Figura de Flor Magenta",
  "block.minecraft.banner.flower.orange": "Figura de Flor Laranja",
  "block.minecraft.banner.flower.pink": "Figura de Flor Rosa",
  "block.minecraft.banner.flower.purple": "Figura de Flor Roxa",
  "block.minecraft.banner.flower.red": "Figura de Flor Vermelha",
  "block.minecraft.banner.flower.white": "Figura de Flor Branca",
  "block.minecraft.banner.flower.yellow": "Figura de Flor Amarela",
  "block.minecraft.banner.globe.black": "Globo Preto",
  "block.minecraft.banner.globe.blue": "Globo Azul",
  "block.minecraft.banner.globe.brown": "Globo Castanho",
  "block.minecraft.banner.globe.cyan": "Globo Cíano",
  "block.minecraft.banner.globe.gray": "Globo Cinzento",
  "block.minecraft.banner.globe.green": "Globo Verde",
  "block.minecraft.banner.globe.light_blue": "Globo Azul-Claro",
  "block.minecraft.banner.globe.light_gray": "Globo Cinzento-Claro",
  "block.minecraft.banner.globe.lime": "Globo Verde-Lima",
  "block.minecraft.banner.globe.magenta": "Globo Magenta",
  "block.minecraft.banner.globe.orange": "Globo Laranja",
  "block.minecraft.banner.globe.pink": "Globo Rosa",
  "block.minecraft.banner.globe.purple": "Globo Roxo",
  "block.minecraft.banner.globe.red": "Globo Vermelho",
  "block.minecraft.banner.globe.white": "Globo Branco",
  "block.minecraft.banner.globe.yellow": "Globo Amarelo",
  "block.minecraft.banner.gradient.black": "Esbatimento Preto",
  "block.minecraft.banner.gradient.blue": "Esbatimento Azul",
  "block.minecraft.banner.gradient.brown": "Esbatimento Castanho",
  "block.minecraft.banner.gradient.cyan": "Esbatimento Cíano",
  "block.minecraft.banner.gradient.gray": "Esbatimento Cinzento",
  "block.minecraft.banner.gradient.green": "Esbatimento Verde",
  "block.minecraft.banner.gradient.light_blue": "Esbatimento Azul-Claro",
  "block.minecraft.banner.gradient.light_gray": "Esbatimento Cinzento-Claro",
  "block.minecraft.banner.gradient.lime": "Esbatimento Verde-Lima",
  "block.minecraft.banner.gradient.magenta": "Esbatimento Magenta",
  "block.minecraft.banner.gradient.orange": "Esbatimento Laranja",
  "block.minecraft.banner.gradient.pink": "Esbatimento Rosa",
  "block.minecraft.banner.gradient.purple": "Esbatimento Roxo",
  "block.minecraft.banner.gradient.red": "Esbatimento Vermelho",
  "block.minecraft.banner.gradient.white": "Esbatimento Branco",
  "block.minecraft.banner.gradient.yellow": "Esbatimento Amarelo",
  "block.minecraft.banner.gradient_up.black": "Esbatimento Basal Preto",
  "block.minecraft.banner.gradient_up.blue": "Esbatimento Basal Azul",
  "block.minecraft.banner.gradient_up.brown": "Esbatimento Basal Castanho",
  "block.minecraft.banner.gradient_up.cyan": "Esbatimento Basal Cíano",
  "block.minecraft.banner.gradient_up.gray": "Esbatimento Basal Cinzento",
  "block.minecraft.banner.gradient_up.green": "Esbatimento Basal Verde",
  "block.minecraft.banner.gradient_up.light_blue": "Esbatimento Basal Azul-Claro",
  "block.minecraft.banner.gradient_up.light_gray": "Esbatimento Basal Cinzento-Claro",
  "block.minecraft.banner.gradient_up.lime": "Esbatimento Basal Verde-Lima",
  "block.minecraft.banner.gradient_up.magenta": "Esbatimento Basal Magenta",
  "block.minecraft.banner.gradient_up.orange": "Esbatimento Basal Laranja",
  "block.minecraft.banner.gradient_up.pink": "Esbatimento Basal Rosa",
  "block.minecraft.banner.gradient_up.purple": "Esbatimento Basal Roxo",
  "block.minecraft.banner.gradient_up.red": "Esbatimento Basal Vermelho",
  "block.minecraft.banner.gradient_up.white": "Esbatimento Basal Branco",
  "block.minecraft.banner.gradient_up.yellow": "Esbatimento Basal Amarelo",
  "block.minecraft.banner.guster.black": "Vórtice Preto",
  "block.minecraft.banner.guster.blue": "Vórtice Azul",
  "block.minecraft.banner.guster.brown": "Vórtice Castanho",
  "block.minecraft.banner.guster.cyan": "Vórtice Cíano",
  "block.minecraft.banner.guster.gray": "Vórtice Cinzento",
  "block.minecraft.banner.guster.green": "Vórtice Verde",
  "block.minecraft.banner.guster.light_blue": "Vórtice Azul-Claro",
  "block.minecraft.banner.guster.light_gray": "Vórtice Cinzento-Claro",
  "block.minecraft.banner.guster.lime": "Vórtice Verde-Lima",
  "block.minecraft.banner.guster.magenta": "Vórtice Magenta",
  "block.minecraft.banner.guster.orange": "Vórtice Laranja",
  "block.minecraft.banner.guster.pink": "Vórtice Rosa",
  "block.minecraft.banner.guster.purple": "Vórtice Roxo",
  "block.minecraft.banner.guster.red": "Vórtice Vermelho",
  "block.minecraft.banner.guster.white": "Vórtice Branco",
  "block.minecraft.banner.guster.yellow": "Vórtice Amarelo",
  "block.minecraft.banner.half_horizontal.black": "Cortado Preto",
  "block.minecraft.banner.half_horizontal.blue": "Cortado Azul",
  "block.minecraft.banner.half_horizontal.brown": "Cortado Castanho",
  "block.minecraft.banner.half_horizontal.cyan": "Cortado Cíano",
  "block.minecraft.banner.half_horizontal.gray": "Cortado Cinzento",
  "block.minecraft.banner.half_horizontal.green": "Cortado Verde",
  "block.minecraft.banner.half_horizontal.light_blue": "Cortado Azul-Claro",
  "block.minecraft.banner.half_horizontal.light_gray": "Cortado Cinzento-Claro",
  "block.minecraft.banner.half_horizontal.lime": "Cortado Verde-Lima",
  "block.minecraft.banner.half_horizontal.magenta": "Cortado Magenta",
  "block.minecraft.banner.half_horizontal.orange": "Cortado Laranja",
  "block.minecraft.banner.half_horizontal.pink": "Cortado Rosa",
  "block.minecraft.banner.half_horizontal.purple": "Cortado Roxo",
  "block.minecraft.banner.half_horizontal.red": "Cortado Vermelho",
  "block.minecraft.banner.half_horizontal.white": "Cortado Branco",
  "block.minecraft.banner.half_horizontal.yellow": "Cortado Amarelo",
  "block.minecraft.banner.half_horizontal_bottom.black": "Cortado Preto Invertido",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Cortado Azul Invertido",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Cortado Castanho Invertido",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cortado Cíano Invertido",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Cortado Cinzento Invertido",
  "block.minecraft.banner.half_horizontal_bottom.green": "Cortado Verde Invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Cortado Azul-Claro Invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Cortado Cinzento-Claro Invertido",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Cortado Verde-Lima Invertido",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Cortado Magenta Invertido",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Cortado Laranja Invertido",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Cortado Rosa Invertido",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Cortado Roxo Invertido",
  "block.minecraft.banner.half_horizontal_bottom.red": "Cortado Vermelho Invertido",
  "block.minecraft.banner.half_horizontal_bottom.white": "Cortado Branco Invertido",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Cortado Amarelo Invertido",
  "block.minecraft.banner.half_vertical.black": "Partido Preto",
  "block.minecraft.banner.half_vertical.blue": "Partido Azul",
  "block.minecraft.banner.half_vertical.brown": "Partido Castanho",
  "block.minecraft.banner.half_vertical.cyan": "Partido Cíano",
  "block.minecraft.banner.half_vertical.gray": "Partido Cinzento",
  "block.minecraft.banner.half_vertical.green": "Partido Verde",
  "block.minecraft.banner.half_vertical.light_blue": "Partido Azul-Claro",
  "block.minecraft.banner.half_vertical.light_gray": "Partido Cinzento-Claro",
  "block.minecraft.banner.half_vertical.lime": "Partido Verde-Lima",
  "block.minecraft.banner.half_vertical.magenta": "Partido Magenta",
  "block.minecraft.banner.half_vertical.orange": "Partido Laranja",
  "block.minecraft.banner.half_vertical.pink": "Partido Rosa",
  "block.minecraft.banner.half_vertical.purple": "Partido Roxo",
  "block.minecraft.banner.half_vertical.red": "Partido Vermelho",
  "block.minecraft.banner.half_vertical.white": "Partido Branco",
  "block.minecraft.banner.half_vertical.yellow": "Partido Amarelo",
  "block.minecraft.banner.half_vertical_right.black": "Partido Preto Invertido",
  "block.minecraft.banner.half_vertical_right.blue": "Partido Azul Invertido",
  "block.minecraft.banner.half_vertical_right.brown": "Partido Castanho Invertido",
  "block.minecraft.banner.half_vertical_right.cyan": "Partido Cíano Invertido",
  "block.minecraft.banner.half_vertical_right.gray": "Partido Cinzento Invertido",
  "block.minecraft.banner.half_vertical_right.green": "Partido Verde Invertido",
  "block.minecraft.banner.half_vertical_right.light_blue": "Partido Azul-Claro Invertido",
  "block.minecraft.banner.half_vertical_right.light_gray": "Partido Cinzento-Claro Invertido",
  "block.minecraft.banner.half_vertical_right.lime": "Partido Verde-Lima Invertido",
  "block.minecraft.banner.half_vertical_right.magenta": "Partido Magenta Invertido",
  "block.minecraft.banner.half_vertical_right.orange": "Partido Laranja Invertido",
  "block.minecraft.banner.half_vertical_right.pink": "Partido Rosa Invertido",
  "block.minecraft.banner.half_vertical_right.purple": "Partido Roxo Invertido",
  "block.minecraft.banner.half_vertical_right.red": "Partido Vermelho Invertido",
  "block.minecraft.banner.half_vertical_right.white": "Partido Branco Invertido",
  "block.minecraft.banner.half_vertical_right.yellow": "Partido Amarelo Invertido",
  "block.minecraft.banner.mojang.black": "Insígnia Preta",
  "block.minecraft.banner.mojang.blue": "Insígnia Azul",
  "block.minecraft.banner.mojang.brown": "Insígnia Castanha",
  "block.minecraft.banner.mojang.cyan": "Insígnia Cíano",
  "block.minecraft.banner.mojang.gray": "Insígnia Cinzenta",
  "block.minecraft.banner.mojang.green": "Insígnia Verde",
  "block.minecraft.banner.mojang.light_blue": "Insígnia Azul-Clara",
  "block.minecraft.banner.mojang.light_gray": "Insígnia Cinzento-Clara",
  "block.minecraft.banner.mojang.lime": "Insígnia Verde-Lima",
  "block.minecraft.banner.mojang.magenta": "Insígnia Magenta",
  "block.minecraft.banner.mojang.orange": "Insígnia Laranja",
  "block.minecraft.banner.mojang.pink": "Insígnia Rosa",
  "block.minecraft.banner.mojang.purple": "Insígnia Roxa",
  "block.minecraft.banner.mojang.red": "Insígnia Vermelha",
  "block.minecraft.banner.mojang.white": "Insígnia Branca",
  "block.minecraft.banner.mojang.yellow": "Insígnia Amarela",
  "block.minecraft.banner.piglin.black": "Focinho Preto",
  "block.minecraft.banner.piglin.blue": "Focinho Azul",
  "block.minecraft.banner.piglin.brown": "Focinho Castanho",
  "block.minecraft.banner.piglin.cyan": "Focinho Cíano",
  "block.minecraft.banner.piglin.gray": "Focinho Cinzento",
  "block.minecraft.banner.piglin.green": "Focinho Verde",
  "block.minecraft.banner.piglin.light_blue": "Focinho Azul-Claro",
  "block.minecraft.banner.piglin.light_gray": "Focinho Cinzento-Claro",
  "block.minecraft.banner.piglin.lime": "Focinho Verde-Lima",
  "block.minecraft.banner.piglin.magenta": "Focinho Magenta",
  "block.minecraft.banner.piglin.orange": "Focinho Laranja",
  "block.minecraft.banner.piglin.pink": "Focinho Rosa",
  "block.minecraft.banner.piglin.purple": "Focinho Roxo",
  "block.minecraft.banner.piglin.red": "Focinho Vermelho",
  "block.minecraft.banner.piglin.white": "Focinho Branco",
  "block.minecraft.banner.piglin.yellow": "Focinho Amarelo",
  "block.minecraft.banner.rhombus.black": "Losango Preto",
  "block.minecraft.banner.rhombus.blue": "Losango Azul",
  "block.minecraft.banner.rhombus.brown": "Losango Castanho",
  "block.minecraft.banner.rhombus.cyan": "Losango Cíano",
  "block.minecraft.banner.rhombus.gray": "Losango Cinzento",
  "block.minecraft.banner.rhombus.green": "Losango Verde",
  "block.minecraft.banner.rhombus.light_blue": "Losango Azul-Claro",
  "block.minecraft.banner.rhombus.light_gray": "Losango Cinzento-Claro",
  "block.minecraft.banner.rhombus.lime": "Losango Verde-Lima",
  "block.minecraft.banner.rhombus.magenta": "Losango Magenta",
  "block.minecraft.banner.rhombus.orange": "Losango Laranja",
  "block.minecraft.banner.rhombus.pink": "Losango Rosa",
  "block.minecraft.banner.rhombus.purple": "Losango Roxo",
  "block.minecraft.banner.rhombus.red": "Losango Vermelho",
  "block.minecraft.banner.rhombus.white": "Losango Branco",
  "block.minecraft.banner.rhombus.yellow": "Losango Amarelo",
  "block.minecraft.banner.skull.black": "Figura de Caveira Preta",
  "block.minecraft.banner.skull.blue": "Figura de Caveira Azul",
  "block.minecraft.banner.skull.brown": "Figura de Caveira Castanha",
  "block.minecraft.banner.skull.cyan": "Figura de Caveira Cíano",
  "block.minecraft.banner.skull.gray": "Figura de Caveira Cinzenta",
  "block.minecraft.banner.skull.green": "Figura de Caveira Verde",
  "block.minecraft.banner.skull.light_blue": "Figura de Caveira Azul-Clara",
  "block.minecraft.banner.skull.light_gray": "Figura de Caveira Cinzento-Clara",
  "block.minecraft.banner.skull.lime": "Figura de Caveira Verde-Lima",
  "block.minecraft.banner.skull.magenta": "Figura de Caveira Magenta",
  "block.minecraft.banner.skull.orange": "Figura de Caveira Laranja",
  "block.minecraft.banner.skull.pink": "Figura de Caveira Rosa",
  "block.minecraft.banner.skull.purple": "Figura de Caveira Roxa",
  "block.minecraft.banner.skull.red": "Figura de Caveira Vermelha",
  "block.minecraft.banner.skull.white": "Figura de Caveira Branca",
  "block.minecraft.banner.skull.yellow": "Figura de Caveira Amarela",
  "block.minecraft.banner.small_stripes.black": "Palado Preto",
  "block.minecraft.banner.small_stripes.blue": "Palado Azul",
  "block.minecraft.banner.small_stripes.brown": "Palado Castanho",
  "block.minecraft.banner.small_stripes.cyan": "Palado Cíano",
  "block.minecraft.banner.small_stripes.gray": "Palado Cinzento",
  "block.minecraft.banner.small_stripes.green": "Palado Verde",
  "block.minecraft.banner.small_stripes.light_blue": "Palado Azul-Claro",
  "block.minecraft.banner.small_stripes.light_gray": "Palado Cinzento-Claro",
  "block.minecraft.banner.small_stripes.lime": "Palado Verde-Lima",
  "block.minecraft.banner.small_stripes.magenta": "Palado Magenta",
  "block.minecraft.banner.small_stripes.orange": "Palado Laranja",
  "block.minecraft.banner.small_stripes.pink": "Palado Rosa",
  "block.minecraft.banner.small_stripes.purple": "Palado Roxo",
  "block.minecraft.banner.small_stripes.red": "Palado Vermelho",
  "block.minecraft.banner.small_stripes.white": "Palado Branco",
  "block.minecraft.banner.small_stripes.yellow": "Palado Amarelo",
  "block.minecraft.banner.square_bottom_left.black": "Cantão Preto na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.blue": "Cantão Azul na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.brown": "Cantão Castanho na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.cyan": "Cantão Cíano na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.gray": "Cantão Cinzento na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.green": "Cantão Verde na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cantão Azul-Claro na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cantão Cinzento-Claro na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.lime": "Cantão Verde-Lima na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.magenta": "Cantão Magenta na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.orange": "Cantão Laranja na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.pink": "Cantão Rosa na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.purple": "Cantão Roxo na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.red": "Cantão Vermelho na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.white": "Cantão Branco na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.yellow": "Cantão Amarelo na Ponta Dextra",
  "block.minecraft.banner.square_bottom_right.black": "Cantão Preto na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.blue": "Cantão Azul na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.brown": "Cantão Castanho na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.cyan": "Cantão Cíano na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.gray": "Cantão Cinzento na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.green": "Cantão Verde na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cantão Azul-Claro na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cantão Cinzento-Claro na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.lime": "Cantão Verde-Lima na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.magenta": "Cantão Magenta na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.orange": "Cantão Laranja na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.pink": "Cantão Rosa na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.purple": "Cantão Roxo na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.red": "Cantão Vermelho na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.white": "Cantão Branco na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.yellow": "Cantão Amarelo na Ponta Sinistra",
  "block.minecraft.banner.square_top_left.black": "Cantão Preto no Chefe Dextro",
  "block.minecraft.banner.square_top_left.blue": "Cantão Azul no Chefe Dextro",
  "block.minecraft.banner.square_top_left.brown": "Cantão Castanho no Chefe Dextro",
  "block.minecraft.banner.square_top_left.cyan": "Cantão Cíano no Chefe Dextro",
  "block.minecraft.banner.square_top_left.gray": "Cantão Cinzento no Chefe Dextro",
  "block.minecraft.banner.square_top_left.green": "Cantão Verde no Chefe Dextro",
  "block.minecraft.banner.square_top_left.light_blue": "Cantão Azul-Claro no Chefe Dextro",
  "block.minecraft.banner.square_top_left.light_gray": "Cantão Cinzento-Claro no Chefe Dextro",
  "block.minecraft.banner.square_top_left.lime": "Cantão Verde-Lima no Chefe Dextro",
  "block.minecraft.banner.square_top_left.magenta": "Cantão Magenta no Chefe Dextro",
  "block.minecraft.banner.square_top_left.orange": "Cantão Laranja no Chefe Dextro",
  "block.minecraft.banner.square_top_left.pink": "Cantão Rosa no Chefe Dextro",
  "block.minecraft.banner.square_top_left.purple": "Cantão Roxo no Chefe Dextro",
  "block.minecraft.banner.square_top_left.red": "Cantão Vermelho no Chefe Dextro",
  "block.minecraft.banner.square_top_left.white": "Cantão Branco no Chefe Dextro",
  "block.minecraft.banner.square_top_left.yellow": "Cantão Amarelo no Chefe Dextro",
  "block.minecraft.banner.square_top_right.black": "Cantão Preto no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.blue": "Cantão Azul no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.brown": "Cantão Castanho no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.cyan": "Cantão Cíano no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.gray": "Cantão Cinzento no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.green": "Cantão Verde no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.light_blue": "Cantão Azul-Claro no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.light_gray": "Cantão Cinzento-Claro no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.lime": "Cantão Verde-Lima no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.magenta": "Cantão Magenta no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.orange": "Cantão Laranja no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.pink": "Cantão Rosa no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.purple": "Cantão Roxo no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.red": "Cantão Vermelho no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.white": "Cantão Branco no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.yellow": "Cantão Amarelo no Chefe Sinistro",
  "block.minecraft.banner.straight_cross.black": "Cruz Preta",
  "block.minecraft.banner.straight_cross.blue": "Cruz Azul",
  "block.minecraft.banner.straight_cross.brown": "Cruz Castanha",
  "block.minecraft.banner.straight_cross.cyan": "Cruz Cíano",
  "block.minecraft.banner.straight_cross.gray": "Cruz Cinzenta",
  "block.minecraft.banner.straight_cross.green": "Cruz Verde",
  "block.minecraft.banner.straight_cross.light_blue": "Cruz Azul-Clara",
  "block.minecraft.banner.straight_cross.light_gray": "Cruz Cinzento-Clara",
  "block.minecraft.banner.straight_cross.lime": "Cruz Verde-Lima",
  "block.minecraft.banner.straight_cross.magenta": "Cruz Magenta",
  "block.minecraft.banner.straight_cross.orange": "Cruz Laranja",
  "block.minecraft.banner.straight_cross.pink": "Cruz Rosa",
  "block.minecraft.banner.straight_cross.purple": "Cruz Roxa",
  "block.minecraft.banner.straight_cross.red": "Cruz Vermelha",
  "block.minecraft.banner.straight_cross.white": "Cruz Branca",
  "block.minecraft.banner.straight_cross.yellow": "Cruz Amarela",
  "block.minecraft.banner.stripe_bottom.black": "Base Preta",
  "block.minecraft.banner.stripe_bottom.blue": "Base Azul",
  "block.minecraft.banner.stripe_bottom.brown": "Base Castanha",
  "block.minecraft.banner.stripe_bottom.cyan": "Base Cíano",
  "block.minecraft.banner.stripe_bottom.gray": "Base Cinzenta",
  "block.minecraft.banner.stripe_bottom.green": "Base Verde",
  "block.minecraft.banner.stripe_bottom.light_blue": "Base Azul-Clara",
  "block.minecraft.banner.stripe_bottom.light_gray": "Base Cinzento-Clara",
  "block.minecraft.banner.stripe_bottom.lime": "Base Verde-Lima",
  "block.minecraft.banner.stripe_bottom.magenta": "Base Magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Base Laranja",
  "block.minecraft.banner.stripe_bottom.pink": "Base Rosa",
  "block.minecraft.banner.stripe_bottom.purple": "Base Roxa",
  "block.minecraft.banner.stripe_bottom.red": "Base Vermelha",
  "block.minecraft.banner.stripe_bottom.white": "Base Branca",
  "block.minecraft.banner.stripe_bottom.yellow": "Base Amarela",
  "block.minecraft.banner.stripe_center.black": "Pala Preta",
  "block.minecraft.banner.stripe_center.blue": "Pala Azul",
  "block.minecraft.banner.stripe_center.brown": "Pala Castanha",
  "block.minecraft.banner.stripe_center.cyan": "Pala Cíano",
  "block.minecraft.banner.stripe_center.gray": "Pala Cinzenta",
  "block.minecraft.banner.stripe_center.green": "Pala Verde",
  "block.minecraft.banner.stripe_center.light_blue": "Pala Azul-Clara",
  "block.minecraft.banner.stripe_center.light_gray": "Pala Cinzento-Clara",
  "block.minecraft.banner.stripe_center.lime": "Pala Verde-Lima",
  "block.minecraft.banner.stripe_center.magenta": "Pala Magenta",
  "block.minecraft.banner.stripe_center.orange": "Pala Laranja",
  "block.minecraft.banner.stripe_center.pink": "Pala Rosa",
  "block.minecraft.banner.stripe_center.purple": "Pala Roxa",
  "block.minecraft.banner.stripe_center.red": "Pala Vermelha",
  "block.minecraft.banner.stripe_center.white": "Pala Branca",
  "block.minecraft.banner.stripe_center.yellow": "Pala Amarela",
  "block.minecraft.banner.stripe_downleft.black": "Banda Sinistra Preta",
  "block.minecraft.banner.stripe_downleft.blue": "Banda Sinistra Azul",
  "block.minecraft.banner.stripe_downleft.brown": "Banda Sinistra Castanha",
  "block.minecraft.banner.stripe_downleft.cyan": "Banda Sinistra Cíano",
  "block.minecraft.banner.stripe_downleft.gray": "Banda Sinistra Cinzenta",
  "block.minecraft.banner.stripe_downleft.green": "Banda Sinistra Verde",
  "block.minecraft.banner.stripe_downleft.light_blue": "Banda Sinistra Azul-Clara",
  "block.minecraft.banner.stripe_downleft.light_gray": "Banda Sinistra Cinzento-Clara",
  "block.minecraft.banner.stripe_downleft.lime": "Banda Sinistra Verde-Lima",
  "block.minecraft.banner.stripe_downleft.magenta": "Banda Sinistra Magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Banda Sinistra Laranja",
  "block.minecraft.banner.stripe_downleft.pink": "Banda Sinistra Rosa",
  "block.minecraft.banner.stripe_downleft.purple": "Banda Sinistra Roxa",
  "block.minecraft.banner.stripe_downleft.red": "Banda Sinistra Vermelha",
  "block.minecraft.banner.stripe_downleft.white": "Banda Sinistra Branca",
  "block.minecraft.banner.stripe_downleft.yellow": "Banda Sinistra Amarela",
  "block.minecraft.banner.stripe_downright.black": "Banda Preta",
  "block.minecraft.banner.stripe_downright.blue": "Banda Azul",
  "block.minecraft.banner.stripe_downright.brown": "Banda Castanha",
  "block.minecraft.banner.stripe_downright.cyan": "Banda Cíano",
  "block.minecraft.banner.stripe_downright.gray": "Banda Cinzenta",
  "block.minecraft.banner.stripe_downright.green": "Banda Verde",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda Azul-Clara",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda Cinzento-Clara",
  "block.minecraft.banner.stripe_downright.lime": "Banda Verde-Lima",
  "block.minecraft.banner.stripe_downright.magenta": "Banda Magenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda Laranja",
  "block.minecraft.banner.stripe_downright.pink": "Banda Rosa",
  "block.minecraft.banner.stripe_downright.purple": "Banda Roxa",
  "block.minecraft.banner.stripe_downright.red": "Banda Vermelha",
  "block.minecraft.banner.stripe_downright.white": "Banda Branca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda Amarela",
  "block.minecraft.banner.stripe_left.black": "Pala Dextra Preta",
  "block.minecraft.banner.stripe_left.blue": "Pala Dextra Azul",
  "block.minecraft.banner.stripe_left.brown": "Pala Dextra Castanha",
  "block.minecraft.banner.stripe_left.cyan": "Pala Dextra Cíano",
  "block.minecraft.banner.stripe_left.gray": "Pala Dextra Cinzenta",
  "block.minecraft.banner.stripe_left.green": "Pala Dextra Verde",
  "block.minecraft.banner.stripe_left.light_blue": "Pala Dextra Azul-Clara",
  "block.minecraft.banner.stripe_left.light_gray": "Pala Dextra Cinzento-Clara",
  "block.minecraft.banner.stripe_left.lime": "Pala Dextra Verde-Lima",
  "block.minecraft.banner.stripe_left.magenta": "Pala Dextra Magenta",
  "block.minecraft.banner.stripe_left.orange": "Pala Dextra Laranja",
  "block.minecraft.banner.stripe_left.pink": "Pala Dextra Rosa",
  "block.minecraft.banner.stripe_left.purple": "Pala Dextra Roxa",
  "block.minecraft.banner.stripe_left.red": "Pala Dextra Vermelha",
  "block.minecraft.banner.stripe_left.white": "Pala Dextra Branca",
  "block.minecraft.banner.stripe_left.yellow": "Pala Dextra Amarela",
  "block.minecraft.banner.stripe_middle.black": "Faixa Preta",
  "block.minecraft.banner.stripe_middle.blue": "Faixa Azul",
  "block.minecraft.banner.stripe_middle.brown": "Faixa Castanha",
  "block.minecraft.banner.stripe_middle.cyan": "Faixa Cíano",
  "block.minecraft.banner.stripe_middle.gray": "Faixa Cinzenta",
  "block.minecraft.banner.stripe_middle.green": "Faixa Verde",
  "block.minecraft.banner.stripe_middle.light_blue": "Faixa Azul-Clara",
  "block.minecraft.banner.stripe_middle.light_gray": "Faixa Cinzento-Clara",
  "block.minecraft.banner.stripe_middle.lime": "Faixa Verde-Lima",
  "block.minecraft.banner.stripe_middle.magenta": "Faixa Magenta",
  "block.minecraft.banner.stripe_middle.orange": "Faixa Laranja",
  "block.minecraft.banner.stripe_middle.pink": "Faixa Rosa",
  "block.minecraft.banner.stripe_middle.purple": "Faixa Roxa",
  "block.minecraft.banner.stripe_middle.red": "Faixa Vermelha",
  "block.minecraft.banner.stripe_middle.white": "Faixa Branca",
  "block.minecraft.banner.stripe_middle.yellow": "Faixa Amarela",
  "block.minecraft.banner.stripe_right.black": "Pala Sinistra Preta",
  "block.minecraft.banner.stripe_right.blue": "Pala Sinistra Azul",
  "block.minecraft.banner.stripe_right.brown": "Pala Sinistra Castanha",
  "block.minecraft.banner.stripe_right.cyan": "Pala Sinistra Cíano",
  "block.minecraft.banner.stripe_right.gray": "Pala Sinistra Cinzenta",
  "block.minecraft.banner.stripe_right.green": "Pala Sinistra Verde",
  "block.minecraft.banner.stripe_right.light_blue": "Pala Sinistra Azul-Clara",
  "block.minecraft.banner.stripe_right.light_gray": "Pala Sinistra Cinzento-Clara",
  "block.minecraft.banner.stripe_right.lime": "Pala Sinistra Verde-Lima",
  "block.minecraft.banner.stripe_right.magenta": "Pala Sinistra Magenta",
  "block.minecraft.banner.stripe_right.orange": "Pala Sinistra Laranja",
  "block.minecraft.banner.stripe_right.pink": "Pala Sinistra Rosa",
  "block.minecraft.banner.stripe_right.purple": "Pala Sinistra Roxa",
  "block.minecraft.banner.stripe_right.red": "Pala Sinistra Vermelha",
  "block.minecraft.banner.stripe_right.white": "Pala Sinistra Branca",
  "block.minecraft.banner.stripe_right.yellow": "Pala Sinistra Amarela",
  "block.minecraft.banner.stripe_top.black": "Chefe Preto",
  "block.minecraft.banner.stripe_top.blue": "Chefe Azul",
  "block.minecraft.banner.stripe_top.brown": "Chefe Castanho",
  "block.minecraft.banner.stripe_top.cyan": "Chefe Cíano",
  "block.minecraft.banner.stripe_top.gray": "Chefe Cinzento",
  "block.minecraft.banner.stripe_top.green": "Chefe Verde",
  "block.minecraft.banner.stripe_top.light_blue": "Chefe Azul-Claro",
  "block.minecraft.banner.stripe_top.light_gray": "Chefe Cinzento-Claro",
  "block.minecraft.banner.stripe_top.lime": "Chefe Verde-Lima",
  "block.minecraft.banner.stripe_top.magenta": "Chefe Magenta",
  "block.minecraft.banner.stripe_top.orange": "Chefe Laranja",
  "block.minecraft.banner.stripe_top.pink": "Chefe Rosa",
  "block.minecraft.banner.stripe_top.purple": "Chefe Roxo",
  "block.minecraft.banner.stripe_top.red": "Chefe Vermelho",
  "block.minecraft.banner.stripe_top.white": "Chefe Branco",
  "block.minecraft.banner.stripe_top.yellow": "Chefe Amarelo",
  "block.minecraft.banner.triangle_bottom.black": "Asna Preta",
  "block.minecraft.banner.triangle_bottom.blue": "Asna Azul",
  "block.minecraft.banner.triangle_bottom.brown": "Asna Castanha",
  "block.minecraft.banner.triangle_bottom.cyan": "Asna Cíano",
  "block.minecraft.banner.triangle_bottom.gray": "Asna Cinzenta",
  "block.minecraft.banner.triangle_bottom.green": "Asna Verde",
  "block.minecraft.banner.triangle_bottom.light_blue": "Asna Azul-Clara",
  "block.minecraft.banner.triangle_bottom.light_gray": "Asna Cinzento-Clara",
  "block.minecraft.banner.triangle_bottom.lime": "Asna Verde-Lima",
  "block.minecraft.banner.triangle_bottom.magenta": "Asna Magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Asna Laranja",
  "block.minecraft.banner.triangle_bottom.pink": "Asna Rosa",
  "block.minecraft.banner.triangle_bottom.purple": "Asna Roxa",
  "block.minecraft.banner.triangle_bottom.red": "Asna Vermelha",
  "block.minecraft.banner.triangle_bottom.white": "Asna Branca",
  "block.minecraft.banner.triangle_bottom.yellow": "Asna Amarela",
  "block.minecraft.banner.triangle_top.black": "Asna Preta Invertida",
  "block.minecraft.banner.triangle_top.blue": "Asna Azul Invertida",
  "block.minecraft.banner.triangle_top.brown": "Asna Castanha Invertida",
  "block.minecraft.banner.triangle_top.cyan": "Asna Cíano Invertida",
  "block.minecraft.banner.triangle_top.gray": "Asna Cinzenta Invertida",
  "block.minecraft.banner.triangle_top.green": "Asna Verde Invertida",
  "block.minecraft.banner.triangle_top.light_blue": "Asna Azul-Clara Invertida",
  "block.minecraft.banner.triangle_top.light_gray": "Asna Cinzento-Clara Invertida",
  "block.minecraft.banner.triangle_top.lime": "Asna Verde-Lima Invertida",
  "block.minecraft.banner.triangle_top.magenta": "Asna Magenta Invertida",
  "block.minecraft.banner.triangle_top.orange": "Asna Laranja Invertida",
  "block.minecraft.banner.triangle_top.pink": "Asna Rosa Invertida",
  "block.minecraft.banner.triangle_top.purple": "Asna Roxa Invertida",
  "block.minecraft.banner.triangle_top.red": "Asna Vermelha Invertida",
  "block.minecraft.banner.triangle_top.white": "Asna Branca Invertida",
  "block.minecraft.banner.triangle_top.yellow": "Asna Amarela Invertida",
  "block.minecraft.banner.triangles_bottom.black": "Base Dentada Preta",
  "block.minecraft.banner.triangles_bottom.blue": "Base Dentada Azul",
  "block.minecraft.banner.triangles_bottom.brown": "Base Dentada Castanha",
  "block.minecraft.banner.triangles_bottom.cyan": "Base Dentada Cíano",
  "block.minecraft.banner.triangles_bottom.gray": "Base Dentada Cinzenta",
  "block.minecraft.banner.triangles_bottom.green": "Base Dentada Verde",
  "block.minecraft.banner.triangles_bottom.light_blue": "Base Dentada Azul-Clara",
  "block.minecraft.banner.triangles_bottom.light_gray": "Base Dentada Cinzento-Clara",
  "block.minecraft.banner.triangles_bottom.lime": "Base Dentada Verde-Lima",
  "block.minecraft.banner.triangles_bottom.magenta": "Base Dentada Magenta",
  "block.minecraft.banner.triangles_bottom.orange": "Base Dentada Laranja",
  "block.minecraft.banner.triangles_bottom.pink": "Base Dentada Rosa",
  "block.minecraft.banner.triangles_bottom.purple": "Base Dentada Roxa",
  "block.minecraft.banner.triangles_bottom.red": "Base Dentada Vermelha",
  "block.minecraft.banner.triangles_bottom.white": "Base Dentada Branca",
  "block.minecraft.banner.triangles_bottom.yellow": "Base Dentada Amarela",
  "block.minecraft.banner.triangles_top.black": "Chefe Dentado Preto",
  "block.minecraft.banner.triangles_top.blue": "Chefe Dentado Azul",
  "block.minecraft.banner.triangles_top.brown": "Chefe Dentado Castanho",
  "block.minecraft.banner.triangles_top.cyan": "Chefe Dentado Cíano",
  "block.minecraft.banner.triangles_top.gray": "Chefe Dentado Cinzento",
  "block.minecraft.banner.triangles_top.green": "Chefe Dentado Verde",
  "block.minecraft.banner.triangles_top.light_blue": "Chefe Dentado Azul-Claro",
  "block.minecraft.banner.triangles_top.light_gray": "Chefe dentado Cinzento-Claro",
  "block.minecraft.banner.triangles_top.lime": "Chefe Dentado Verde-Lima",
  "block.minecraft.banner.triangles_top.magenta": "Chefe Dentado Magenta",
  "block.minecraft.banner.triangles_top.orange": "Chefe Dentado Laranja",
  "block.minecraft.banner.triangles_top.pink": "Chefe Dentado Rosa",
  "block.minecraft.banner.triangles_top.purple": "Chefe Dentado Roxo",
  "block.minecraft.banner.triangles_top.red": "Chefe Dentado Vermelho",
  "block.minecraft.banner.triangles_top.white": "Chefe Dentado Branco",
  "block.minecraft.banner.triangles_top.yellow": "Chefe Dentado Amarelo",
  "block.minecraft.barrel": "Barril",
  "block.minecraft.barrier": "Barreira",
  "block.minecraft.basalt": "Basalto",
  "block.minecraft.beacon": "Sinalizador",
  "block.minecraft.beacon.primary": "Poder primário",
  "block.minecraft.beacon.secondary": "Poder secundário",
  "block.minecraft.bed.no_sleep": "Só podes dormir à noite ou durante tempestades",
  "block.minecraft.bed.not_safe": "Não podes dormir agora, há monstros por perto",
  "block.minecraft.bed.obstructed": "Esta cama está obstruída",
  "block.minecraft.bed.occupied": "Esta cama está ocupada",
  "block.minecraft.bed.too_far_away": "Não podes dormir agora, a cama está demasiado longe",
  "block.minecraft.bedrock": "Rocha-Mãe",
  "block.minecraft.bee_nest": "Colmeia",
  "block.minecraft.beehive": "Colmeia Artificial",
  "block.minecraft.beetroots": "Beterrabas",
  "block.minecraft.bell": "Sino",
  "block.minecraft.big_dripleaf": "Planta-Goteira Grande",
  "block.minecraft.big_dripleaf_stem": "Caule de Planta-Goteira Grande",
  "block.minecraft.birch_button": "Botão de Bétula",
  "block.minecraft.birch_door": "Porta de Bétula",
  "block.minecraft.birch_fence": "Cerca de Bétula",
  "block.minecraft.birch_fence_gate": "Portão de Bétula",
  "block.minecraft.birch_hanging_sign": "Tabuleta Pendurada de Bétula",
  "block.minecraft.birch_leaves": "Folhas de Bétula",
  "block.minecraft.birch_log": "Tronco de Bétula",
  "block.minecraft.birch_planks": "Tábuas de Bétula",
  "block.minecraft.birch_pressure_plate": "Placa de Pressão de Bétula",
  "block.minecraft.birch_sapling": "Rebento de Bétula",
  "block.minecraft.birch_shelf": "Estante de Bétula",
  "block.minecraft.birch_sign": "Tabuleta de Bétula",
  "block.minecraft.birch_slab": "Degrau de Bétula",
  "block.minecraft.birch_stairs": "Escadas de Bétula",
  "block.minecraft.birch_trapdoor": "Alçapão de Bétula",
  "block.minecraft.birch_wall_hanging_sign": "Tabuleta Pendurada de Bétula de Parede",
  "block.minecraft.birch_wall_sign": "Tabuleta de Bétula de Parede",
  "block.minecraft.birch_wood": "Madeira de Bétula",
  "block.minecraft.black_banner": "Estandarte Preto",
  "block.minecraft.black_bed": "Cama Preta",
  "block.minecraft.black_candle": "Vela Preta",
  "block.minecraft.black_candle_cake": "Bolo com Vela Preta",
  "block.minecraft.black_carpet": "Tapete Preto",
  "block.minecraft.black_concrete": "Betão Preto",
  "block.minecraft.black_concrete_powder": "Betão Preto em Pó",
  "block.minecraft.black_glazed_terracotta": "Azulejo Preto",
  "block.minecraft.black_shulker_box": "Caixa de Shulker Preta",
  "block.minecraft.black_stained_glass": "Vidro Preto",
  "block.minecraft.black_stained_glass_pane": "Vidraça Preta",
  "block.minecraft.black_terracotta": "Terracota Preta",
  "block.minecraft.black_wool": "Lã Preta",
  "block.minecraft.blackstone": "Negrito",
  "block.minecraft.blackstone_slab": "Degrau de Negrito",
  "block.minecraft.blackstone_stairs": "Escadas de Negrito",
  "block.minecraft.blackstone_wall": "Muro de Negrito",
  "block.minecraft.blast_furnace": "Alto-Forno",
  "block.minecraft.blue_banner": "Estandarte Azul",
  "block.minecraft.blue_bed": "Cama Azul",
  "block.minecraft.blue_candle": "Vela Azul",
  "block.minecraft.blue_candle_cake": "Bolo com Vela Azul",
  "block.minecraft.blue_carpet": "Tapete Azul",
  "block.minecraft.blue_concrete": "Betão Azul",
  "block.minecraft.blue_concrete_powder": "Betão Azul em Pó",
  "block.minecraft.blue_glazed_terracotta": "Azulejo Azul",
  "block.minecraft.blue_ice": "Gelo Azul",
  "block.minecraft.blue_orchid": "Orquídea Azul",
  "block.minecraft.blue_shulker_box": "Caixa de Shulker Azul",
  "block.minecraft.blue_stained_glass": "Vidro Azul",
  "block.minecraft.blue_stained_glass_pane": "Vidraça Azul",
  "block.minecraft.blue_terracotta": "Terracota Azul",
  "block.minecraft.blue_wool": "Lã Azul",
  "block.minecraft.bone_block": "Bloco de Ossos",
  "block.minecraft.bookshelf": "Estante de Livros",
  "block.minecraft.brain_coral": "Coral-de-Cérebro",
  "block.minecraft.brain_coral_block": "Bloco de Coral-de-Cérebro",
  "block.minecraft.brain_coral_fan": "Gorgónia-de-Cérebro",
  "block.minecraft.brain_coral_wall_fan": "Gorgónia-de-Cérebro de Parede",
  "block.minecraft.brewing_stand": "Fermentador",
  "block.minecraft.brick_slab": "Degrau de Tijolos",
  "block.minecraft.brick_stairs": "Escadas de Tijolos",
  "block.minecraft.brick_wall": "Muro de Tijolos",
  "block.minecraft.bricks": "Tijolos",
  "block.minecraft.brown_banner": "Estandarte Castanho",
  "block.minecraft.brown_bed": "Cama Castanha",
  "block.minecraft.brown_candle": "Vela Castanha",
  "block.minecraft.brown_candle_cake": "Bolo com Vela Castanha",
  "block.minecraft.brown_carpet": "Tapete Castanho",
  "block.minecraft.brown_concrete": "Betão Castanho",
  "block.minecraft.brown_concrete_powder": "Betão Castanho em Pó",
  "block.minecraft.brown_glazed_terracotta": "Azulejo Castanho",
  "block.minecraft.brown_mushroom": "Cogumelo Castanho",
  "block.minecraft.brown_mushroom_block": "Bloco de Cogumelo Castanho",
  "block.minecraft.brown_shulker_box": "Caixa de Shulker Castanha",
  "block.minecraft.brown_stained_glass": "Vidro Castanho",
  "block.minecraft.brown_stained_glass_pane": "Vidraça Castanha",
  "block.minecraft.brown_terracotta": "Terracota Castanha",
  "block.minecraft.brown_wool": "Lã Castanha",
  "block.minecraft.bubble_column": "Coluna de Bolhas",
  "block.minecraft.bubble_coral": "Coral-de-Bolha",
  "block.minecraft.bubble_coral_block": "Bloco de Coral-de-Bolha",
  "block.minecraft.bubble_coral_fan": "Gorgónia-de-Bolha",
  "block.minecraft.bubble_coral_wall_fan": "Gorgónia-de-Bolha de Parede",
  "block.minecraft.budding_amethyst": "Drusa de Ametista",
  "block.minecraft.bush": "Arbusto",
  "block.minecraft.cactus": "Cato",
  "block.minecraft.cactus_flower": "Flor de Cato",
  "block.minecraft.cake": "Bolo",
  "block.minecraft.calcite": "Calcite",
  "block.minecraft.calibrated_sculk_sensor": "Sensor de Sculk Calibrado",
  "block.minecraft.campfire": "Fogueira",
  "block.minecraft.candle": "Vela",
  "block.minecraft.candle_cake": "Bolo com Vela",
  "block.minecraft.carrots": "Cenouras",
  "block.minecraft.cartography_table": "Mesa Cartográfica",
  "block.minecraft.carved_pumpkin": "Abóbora Talhada",
  "block.minecraft.cauldron": "Caldeirão",
  "block.minecraft.cave_air": "Ar de Caverna",
  "block.minecraft.cave_vines": "Trepadeiras Subterrâneas",
  "block.minecraft.cave_vines_plant": "Planta de Trepadeiras Subterrâneas",
  "block.minecraft.chain": "Corrente",
  "block.minecraft.chain_command_block": "Bloco de Comando em Cadeia",
  "block.minecraft.cherry_button": "Botão de Cerejeira",
  "block.minecraft.cherry_door": "Porta de Cerejeira",
  "block.minecraft.cherry_fence": "Cerca de Cerejeira",
  "block.minecraft.cherry_fence_gate": "Portão de Cerejeira",
  "block.minecraft.cherry_hanging_sign": "Tabuleta Pendurada de Cerejeira",
  "block.minecraft.cherry_leaves": "Folhas de Cerejeira",
  "block.minecraft.cherry_log": "Tronco de Cerejeira",
  "block.minecraft.cherry_planks": "Tábuas de Cerejeira",
  "block.minecraft.cherry_pressure_plate": "Placa de Pressão de Cerejeira",
  "block.minecraft.cherry_sapling": "Rebento de Cerejeira",
  "block.minecraft.cherry_shelf": "Estante de Cerejeira",
  "block.minecraft.cherry_sign": "Tabuleta de Cerejeira",
  "block.minecraft.cherry_slab": "Degrau de Cerejeira",
  "block.minecraft.cherry_stairs": "Escadas de Cerejeira",
  "block.minecraft.cherry_trapdoor": "Alçapão de Cerejeira",
  "block.minecraft.cherry_wall_hanging_sign": "Tabuleta Pendurada de Cerejeira de Parede",
  "block.minecraft.cherry_wall_sign": "Tabuleta de Cerejeira de Parede",
  "block.minecraft.cherry_wood": "Madeira de Cerejeira",
  "block.minecraft.chest": "Baú",
  "block.minecraft.chipped_anvil": "Bigorna Lascada",
  "block.minecraft.chiseled_bookshelf": "Estante de Livros Esculpida",
  "block.minecraft.chiseled_copper": "Cobre Esculpido",
  "block.minecraft.chiseled_deepslate": "Ardósia Esculpida",
  "block.minecraft.chiseled_nether_bricks": "Tijolos do Nether Esculpidos",
  "block.minecraft.chiseled_polished_blackstone": "Negrito Polido Esculpido",
  "block.minecraft.chiseled_quartz_block": "Bloco de Quartzo Esculpido",
  "block.minecraft.chiseled_red_sandstone": "Arenito Vermelho Esculpido",
  "block.minecraft.chiseled_resin_bricks": "Tijolos de Resina Esculpidos",
  "block.minecraft.chiseled_sandstone": "Arenito Esculpido",
  "block.minecraft.chiseled_stone_bricks": "Tijolos de Pedra Esculpidos",
  "block.minecraft.chiseled_tuff": "Tufo Esculpido",
  "block.minecraft.chiseled_tuff_bricks": "Tijolos de Tufo Esculpidos",
  "block.minecraft.chorus_flower": "Flor do Coro",
  "block.minecraft.chorus_plant": "Planta do Coro",
  "block.minecraft.clay": "Argila",
  "block.minecraft.closed_eyeblossom": "Olheira Fechada",
  "block.minecraft.coal_block": "Bloco de Carvão",
  "block.minecraft.coal_ore": "Minério de Carvão",
  "block.minecraft.coarse_dirt": "Terra Infértil",
  "block.minecraft.cobbled_deepslate": "Pedregulho de Ardósia",
  "block.minecraft.cobbled_deepslate_slab": "Degrau de Pedregulho de Ardósia",
  "block.minecraft.cobbled_deepslate_stairs": "Escadas de Pedregulho de Ardósia",
  "block.minecraft.cobbled_deepslate_wall": "Muro de Pedregulho de Ardósia",
  "block.minecraft.cobblestone": "Pedregulho",
  "block.minecraft.cobblestone_slab": "Degrau de Pedregulho",
  "block.minecraft.cobblestone_stairs": "Escadas de Pedregulho",
  "block.minecraft.cobblestone_wall": "Muro de Pedregulho",
  "block.minecraft.cobweb": "Teia de Aranha",
  "block.minecraft.cocoa": "Cacau",
  "block.minecraft.command_block": "Bloco de Comando",
  "block.minecraft.comparator": "Comparador de Redstone",
  "block.minecraft.composter": "Compostor",
  "block.minecraft.conduit": "Conduto",
  "block.minecraft.copper_bars": "Barras de Cobre",
  "block.minecraft.copper_block": "Bloco de Cobre",
  "block.minecraft.copper_bulb": "Lâmpada de Cobre",
  "block.minecraft.copper_chain": "Corrente de Cobre",
  "block.minecraft.copper_chest": "Baú de Cobre",
  "block.minecraft.copper_door": "Porta de Cobre",
  "block.minecraft.copper_golem_statue": "Estátua de Golem de Cobre",
  "block.minecraft.copper_grate": "Grade de Cobre",
  "block.minecraft.copper_lantern": "Lanterna de Cobre",
  "block.minecraft.copper_ore": "Minério de Cobre",
  "block.minecraft.copper_torch": "Tocha de Cobre",
  "block.minecraft.copper_trapdoor": "Alçapão de Cobre",
  "block.minecraft.copper_wall_torch": "Tocha de Cobre de Parede",
  "block.minecraft.cornflower": "Centáurea",
  "block.minecraft.cracked_deepslate_bricks": "Tijolos de Ardósia Rachados",
  "block.minecraft.cracked_deepslate_tiles": "Ladrilhos de Ardósia Rachados",
  "block.minecraft.cracked_nether_bricks": "Tijolos do Nether Rachados",
  "block.minecraft.cracked_polished_blackstone_bricks": "Tijolos de Negrito Polido Rachados",
  "block.minecraft.cracked_stone_bricks": "Tijolos de Pedra Rachados",
  "block.minecraft.crafter": "Mesa Automática",
  "block.minecraft.crafting_table": "Mesa de Trabalho",
  "block.minecraft.creaking_heart": "Coração de Rangente",
  "block.minecraft.creeper_head": "Cabeça de Creeper",
  "block.minecraft.creeper_wall_head": "Cabeça de Creeper de Parede",
  "block.minecraft.crimson_button": "Botão Carmesim",
  "block.minecraft.crimson_door": "Porta Carmesim",
  "block.minecraft.crimson_fence": "Cerca Carmesim",
  "block.minecraft.crimson_fence_gate": "Portão Carmesim",
  "block.minecraft.crimson_fungus": "Fungo Carmesim",
  "block.minecraft.crimson_hanging_sign": "Tabuleta Pendurada Carmesim",
  "block.minecraft.crimson_hyphae": "Hifas Carmesins",
  "block.minecraft.crimson_nylium": "Nicélio Carmesim",
  "block.minecraft.crimson_planks": "Tábuas Carmesins",
  "block.minecraft.crimson_pressure_plate": "Placa de Pressão Carmesim",
  "block.minecraft.crimson_roots": "Raízes Carmesins",
  "block.minecraft.crimson_shelf": "Estante Carmesim",
  "block.minecraft.crimson_sign": "Tabuleta Carmesim",
  "block.minecraft.crimson_slab": "Degrau Carmesim",
  "block.minecraft.crimson_stairs": "Escadas Carmesins",
  "block.minecraft.crimson_stem": "Pé Carmesim",
  "block.minecraft.crimson_trapdoor": "Alçapão Carmesim",
  "block.minecraft.crimson_wall_hanging_sign": "Tabuleta Pendurada Carmesim de Parede",
  "block.minecraft.crimson_wall_sign": "Tabuleta Carmesim de Parede",
  "block.minecraft.crying_obsidian": "Obsidiana Lacrimejante",
  "block.minecraft.cut_copper": "Cobre Cortado",
  "block.minecraft.cut_copper_slab": "Degrau de Cobre Cortado",
  "block.minecraft.cut_copper_stairs": "Escadas de Cobre Cortado",
  "block.minecraft.cut_red_sandstone": "Arenito Vermelho Cortado",
  "block.minecraft.cut_red_sandstone_slab": "Degrau de Arenito Vermelho Cortado",
  "block.minecraft.cut_sandstone": "Arenito Cortado",
  "block.minecraft.cut_sandstone_slab": "Degrau de Arenito Cortado",
  "block.minecraft.cyan_banner": "Estandarte Cíano",
  "block.minecraft.cyan_bed": "Cama Cíano",
  "block.minecraft.cyan_candle": "Vela Cíano",
  "block.minecraft.cyan_candle_cake": "Bolo com Vela Cíano",
  "block.minecraft.cyan_carpet": "Tapete Cíano",
  "block.minecraft.cyan_concrete": "Betão Cíano",
  "block.minecraft.cyan_concrete_powder": "Betão Cíano em Pó",
  "block.minecraft.cyan_glazed_terracotta": "Azulejo Cíano",
  "block.minecraft.cyan_shulker_box": "Caixa de Shulker Cíano",
  "block.minecraft.cyan_stained_glass": "Vidro Cíano",
  "block.minecraft.cyan_stained_glass_pane": "Vidraça Cíano",
  "block.minecraft.cyan_terracotta": "Terracota Cíano",
  "block.minecraft.cyan_wool": "Lã Cíano",
  "block.minecraft.damaged_anvil": "Bigorna Danificada",
  "block.minecraft.dandelion": "Dente-de-Leão",
  "block.minecraft.dark_oak_button": "Botão de Carvalho Escuro",
  "block.minecraft.dark_oak_door": "Porta de Carvalho Escuro",
  "block.minecraft.dark_oak_fence": "Cerca de Carvalho Escuro",
  "block.minecraft.dark_oak_fence_gate": "Portão de Carvalho Escuro",
  "block.minecraft.dark_oak_hanging_sign": "Tabuleta Pendurada de Carvalho Escuro",
  "block.minecraft.dark_oak_leaves": "Folhas de Carvalho Escuro",
  "block.minecraft.dark_oak_log": "Tronco de Carvalho Escuro",
  "block.minecraft.dark_oak_planks": "Tábuas de Carvalho Escuro",
  "block.minecraft.dark_oak_pressure_plate": "Placa de Pressão de Carvalho Escuro",
  "block.minecraft.dark_oak_sapling": "Rebento de Carvalho Escuro",
  "block.minecraft.dark_oak_shelf": "Estante de Carvalho Escuro",
  "block.minecraft.dark_oak_sign": "Tabuleta de Carvalho Escuro",
  "block.minecraft.dark_oak_slab": "Degrau de Carvalho Escuro",
  "block.minecraft.dark_oak_stairs": "Escadas de Carvalho Escuro",
  "block.minecraft.dark_oak_trapdoor": "Alçapão de Carvalho Escuro",
  "block.minecraft.dark_oak_wall_hanging_sign": "Tabuleta Pendurada de Carvalho Escuro de Parede",
  "block.minecraft.dark_oak_wall_sign": "Tabuleta de Carvalho Escuro de Parede",
  "block.minecraft.dark_oak_wood": "Madeira de Carvalho Escuro",
  "block.minecraft.dark_prismarine": "Prismarinho Escuro",
  "block.minecraft.dark_prismarine_slab": "Degrau de Prismarinho Escuro",
  "block.minecraft.dark_prismarine_stairs": "Escadas de Prismarinho Escuro",
  "block.minecraft.daylight_detector": "Detetor de Luz Solar",
  "block.minecraft.dead_brain_coral": "Coral-de-Cérebro Morto",
  "block.minecraft.dead_brain_coral_block": "Bloco de Coral-de-Cérebro Morto",
  "block.minecraft.dead_brain_coral_fan": "Gorgónia-de-Cérebro Morta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgónia-de-Cérebro de Parede Morta",
  "block.minecraft.dead_bubble_coral": "Coral-de-Bolha Morto",
  "block.minecraft.dead_bubble_coral_block": "Bloco de Coral-de-Bolha Morto",
  "block.minecraft.dead_bubble_coral_fan": "Gorgónia-de-Bolha Morta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgónia-de-Bolha Morta de Parede",
  "block.minecraft.dead_bush": "Arbusto Morto",
  "block.minecraft.dead_fire_coral": "Coral-de-Fogo Morto",
  "block.minecraft.dead_fire_coral_block": "Bloco de Coral-de-Fogo Morto",
  "block.minecraft.dead_fire_coral_fan": "Gorgónia-de-Fogo Morta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgónia-de-Fogo Morta de Parede",
  "block.minecraft.dead_horn_coral": "Coral-Corno-de-Cervo Morto",
  "block.minecraft.dead_horn_coral_block": "Bloco de Coral-Corno-de-Cervo Morto",
  "block.minecraft.dead_horn_coral_fan": "Gorgónia-Corno-de-Cervo Morta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgónia-Corno-de-Cervo Morta de Parede",
  "block.minecraft.dead_tube_coral": "Coral-Tubular Morto",
  "block.minecraft.dead_tube_coral_block": "Bloco de Coral-Tubular Morto",
  "block.minecraft.dead_tube_coral_fan": "Gorgónia-Tubular Morta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgónia-Tubular Morta de Parede",
  "block.minecraft.decorated_pot": "Vaso Decorado",
  "block.minecraft.deepslate": "Ardósia",
  "block.minecraft.deepslate_brick_slab": "Degrau de Tijolos de Ardósia",
  "block.minecraft.deepslate_brick_stairs": "Escadas de Tijolos de Ardósia",
  "block.minecraft.deepslate_brick_wall": "Muro de Tijolos de Ardósia",
  "block.minecraft.deepslate_bricks": "Tijolos de Ardósia",
  "block.minecraft.deepslate_coal_ore": "Minério de Carvão de Ardósia",
  "block.minecraft.deepslate_copper_ore": "Minério de Cobre de Ardósia",
  "block.minecraft.deepslate_diamond_ore": "Minério de Diamante de Ardósia",
  "block.minecraft.deepslate_emerald_ore": "Minério de Esmeralda de Ardósia",
  "block.minecraft.deepslate_gold_ore": "Minério de Ouro de Ardósia",
  "block.minecraft.deepslate_iron_ore": "Minério de Ferro de Ardósia",
  "block.minecraft.deepslate_lapis_ore": "Minério de Lápis-Lazúli de Ardósia",
  "block.minecraft.deepslate_redstone_ore": "Minério de Redstone de Ardósia",
  "block.minecraft.deepslate_tile_slab": "Degrau de Ladrilhos de Ardósia",
  "block.minecraft.deepslate_tile_stairs": "Escadas de Ladrilhos de Ardósia",
  "block.minecraft.deepslate_tile_wall": "Muro de Ladrilhos de Ardósia",
  "block.minecraft.deepslate_tiles": "Ladrilhos de Ardósia",
  "block.minecraft.detector_rail": "Carril Detetor",
  "block.minecraft.diamond_block": "Bloco de Diamante",
  "block.minecraft.diamond_ore": "Minério de Diamante",
  "block.minecraft.diorite": "Diorito",
  "block.minecraft.diorite_slab": "Degrau de Diorito",
  "block.minecraft.diorite_stairs": "Escadas de Diorito",
  "block.minecraft.diorite_wall": "Muro de Diorito",
  "block.minecraft.dirt": "Terra",
  "block.minecraft.dirt_path": "Caminho de Terra",
  "block.minecraft.dispenser": "Distribuidor",
  "block.minecraft.dragon_egg": "Ovo do Dragão",
  "block.minecraft.dragon_head": "Cabeça do Dragão",
  "block.minecraft.dragon_wall_head": "Cabeça do Dragão de Parede",
  "block.minecraft.dried_ghast": "Ghast Seco",
  "block.minecraft.dried_kelp_block": "Bloco de Algas Secas",
  "block.minecraft.dripstone_block": "Bloco de Espeleotema",
  "block.minecraft.dropper": "Ejetor",
  "block.minecraft.emerald_block": "Bloco de Esmeralda",
  "block.minecraft.emerald_ore": "Minério de Esmeralda",
  "block.minecraft.enchanting_table": "Mesa de Encantamentos",
  "block.minecraft.end_gateway": "Passagem do End",
  "block.minecraft.end_portal": "Portal do End",
  "block.minecraft.end_portal_frame": "Borda do Portal do End",
  "block.minecraft.end_rod": "Bastão do End",
  "block.minecraft.end_stone": "Pedra do End",
  "block.minecraft.end_stone_brick_slab": "Degrau de Tijolos de Pedra do End",
  "block.minecraft.end_stone_brick_stairs": "Escadas de Tijolos de Pedra do End",
  "block.minecraft.end_stone_brick_wall": "Muro de Tijolos de Pedra do End",
  "block.minecraft.end_stone_bricks": "Tijolos de Pedra do End",
  "block.minecraft.ender_chest": "Baú do Ender",
  "block.minecraft.exposed_chiseled_copper": "Cobre Esculpido Exposto",
  "block.minecraft.exposed_copper": "Cobre Exposto",
  "block.minecraft.exposed_copper_bars": "Barras de Cobre Exposto",
  "block.minecraft.exposed_copper_bulb": "Lâmpada de Cobre Exposto",
  "block.minecraft.exposed_copper_chain": "Corrente de Cobre Exposto",
  "block.minecraft.exposed_copper_chest": "Baú de Cobre Exposto",
  "block.minecraft.exposed_copper_door": "Porta de Cobre Exposto",
  "block.minecraft.exposed_copper_golem_statue": "Estátua de Golem de Cobre Exposto",
  "block.minecraft.exposed_copper_grate": "Grade de Cobre Exposto",
  "block.minecraft.exposed_copper_lantern": "Lanterna de Cobre Exposto",
  "block.minecraft.exposed_copper_trapdoor": "Alçapão de Cobre Exposto",
  "block.minecraft.exposed_cut_copper": "Cobre Cortado Exposto",
  "block.minecraft.exposed_cut_copper_slab": "Degrau de Cobre Cortado Exposto",
  "block.minecraft.exposed_cut_copper_stairs": "Escadas de Cobre Cortado Exposto",
  "block.minecraft.exposed_lightning_rod": "Para-Raios Exposto",
  "block.minecraft.farmland": "Terra Arada",
  "block.minecraft.fern": "Feto",
  "block.minecraft.fire": "Fogo",
  "block.minecraft.fire_coral": "Coral-de-Fogo",
  "block.minecraft.fire_coral_block": "Bloco de Coral-de-Fogo",
  "block.minecraft.fire_coral_fan": "Gorgónia-de-Fogo",
  "block.minecraft.fire_coral_wall_fan": "Gorgónia-de-Fogo de Parede",
  "block.minecraft.firefly_bush": "Arbusto com Pirilampos",
  "block.minecraft.fletching_table": "Mesa de Flechas",
  "block.minecraft.flower_pot": "Vaso",
  "block.minecraft.flowering_azalea": "Azálea Florida",
  "block.minecraft.flowering_azalea_leaves": "Folhas de Azálea Floridas",
  "block.minecraft.frogspawn": "Ovos de Sapo",
  "block.minecraft.frosted_ice": "Gelo Turvo",
  "block.minecraft.furnace": "Fornalha",
  "block.minecraft.gilded_blackstone": "Negrito Dourado",
  "block.minecraft.glass": "Vidro",
  "block.minecraft.glass_pane": "Vidraça",
  "block.minecraft.glow_lichen": "Líquen Brilhante",
  "block.minecraft.glowstone": "Pedra Luminosa",
  "block.minecraft.gold_block": "Bloco de Ouro",
  "block.minecraft.gold_ore": "Minério de Ouro",
  "block.minecraft.golden_dandelion": "Dente-de-Leão Dourado",
  "block.minecraft.granite": "Granito",
  "block.minecraft.granite_slab": "Degrau de Granito",
  "block.minecraft.granite_stairs": "Escadas de Granito",
  "block.minecraft.granite_wall": "Muro de Granito",
  "block.minecraft.grass": "Relva",
  "block.minecraft.grass_block": "Bloco de Relva",
  "block.minecraft.gravel": "Gravilha",
  "block.minecraft.gray_banner": "Estandarte Cinzento",
  "block.minecraft.gray_bed": "Cama Cinzenta",
  "block.minecraft.gray_candle": "Vela Cinzenta",
  "block.minecraft.gray_candle_cake": "Bolo com Vela Cinzenta",
  "block.minecraft.gray_carpet": "Tapete Cinzento",
  "block.minecraft.gray_concrete": "Betão Cinzento",
  "block.minecraft.gray_concrete_powder": "Betão Cinzento em Pó",
  "block.minecraft.gray_glazed_terracotta": "Azulejo Cinzento",
  "block.minecraft.gray_shulker_box": "Caixa de Shulker Cinzenta",
  "block.minecraft.gray_stained_glass": "Vidro Cinzento",
  "block.minecraft.gray_stained_glass_pane": "Vidraça Cinzenta",
  "block.minecraft.gray_terracotta": "Terracota Cinzenta",
  "block.minecraft.gray_wool": "Lã Cinzenta",
  "block.minecraft.green_banner": "Estandarte Verde",
  "block.minecraft.green_bed": "Cama Verde",
  "block.minecraft.green_candle": "Vela Verde",
  "block.minecraft.green_candle_cake": "Bolo com Vela Verde",
  "block.minecraft.green_carpet": "Tapete Verde",
  "block.minecraft.green_concrete": "Betão Verde",
  "block.minecraft.green_concrete_powder": "Betão Verde em Pó",
  "block.minecraft.green_glazed_terracotta": "Azulejo Verde",
  "block.minecraft.green_shulker_box": "Caixa de Shulker Verde",
  "block.minecraft.green_stained_glass": "Vidro Verde",
  "block.minecraft.green_stained_glass_pane": "Vidraça Verde",
  "block.minecraft.green_terracotta": "Terracota Verde",
  "block.minecraft.green_wool": "Lã Verde",
  "block.minecraft.grindstone": "Mó",
  "block.minecraft.hanging_roots": "Raízes Suspensas",
  "block.minecraft.hay_block": "Fardo de Feno",
  "block.minecraft.heavy_core": "Núcleo Pesado",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa de Pressão Medidora Pesada",
  "block.minecraft.honey_block": "Bloco de Mel",
  "block.minecraft.honeycomb_block": "Bloco de Favo de Mel",
  "block.minecraft.hopper": "Funil",
  "block.minecraft.horn_coral": "Coral-Corno-de-Cervo",
  "block.minecraft.horn_coral_block": "Bloco de Coral-Corno-de-Cervo",
  "block.minecraft.horn_coral_fan": "Gorgónia-Corno-de-Cervo",
  "block.minecraft.horn_coral_wall_fan": "Gorgónia-Corno-de-Cervo de Parede",
  "block.minecraft.ice": "Gelo",
  "block.minecraft.infested_chiseled_stone_bricks": "Tijolos de Pedra Esculpidos Infestados",
  "block.minecraft.infested_cobblestone": "Pedregulho Infestado",
  "block.minecraft.infested_cracked_stone_bricks": "Tijolos de Pedra Rachados Infestados",
  "block.minecraft.infested_deepslate": "Ardósia Infestada",
  "block.minecraft.infested_mossy_stone_bricks": "Tijolos de Pedra com Musgo Infestados",
  "block.minecraft.infested_stone": "Pedra Infestada",
  "block.minecraft.infested_stone_bricks": "Tijolos de Pedra Infestados",
  "block.minecraft.iron_bars": "Barras de Ferro",
  "block.minecraft.iron_block": "Bloco de Ferro",
  "block.minecraft.iron_chain": "Corrente de Ferro",
  "block.minecraft.iron_door": "Porta de Ferro",
  "block.minecraft.iron_ore": "Minério de Ferro",
  "block.minecraft.iron_trapdoor": "Alçapão de Ferro",
  "block.minecraft.jack_o_lantern": "Abóbora de Halloween",
  "block.minecraft.jigsaw": "Bloco de Puzzle",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Botão da Selva",
  "block.minecraft.jungle_door": "Porta da Selva",
  "block.minecraft.jungle_fence": "Cerca da Selva",
  "block.minecraft.jungle_fence_gate": "Portão da Selva",
  "block.minecraft.jungle_hanging_sign": "Tabuleta Pendurada da Selva",
  "block.minecraft.jungle_leaves": "Folhas da Selva",
  "block.minecraft.jungle_log": "Tronco da Selva",
  "block.minecraft.jungle_planks": "Tábuas da Selva",
  "block.minecraft.jungle_pressure_plate": "Placa de Pressão da Selva",
  "block.minecraft.jungle_sapling": "Rebento da Selva",
  "block.minecraft.jungle_shelf": "Estante da Selva",
  "block.minecraft.jungle_sign": "Tabuleta da Selva",
  "block.minecraft.jungle_slab": "Degrau da Selva",
  "block.minecraft.jungle_stairs": "Escadas da Selva",
  "block.minecraft.jungle_trapdoor": "Alçapão da Selva",
  "block.minecraft.jungle_wall_hanging_sign": "Tabuleta Pendurada da Selva de Parede",
  "block.minecraft.jungle_wall_sign": "Tabuleta da Selva de Parede",
  "block.minecraft.jungle_wood": "Madeira da Selva",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Pé de Alga",
  "block.minecraft.ladder": "Escada de Mão",
  "block.minecraft.lantern": "Lanterna",
  "block.minecraft.lapis_block": "Bloco de Lápis-Lazúli",
  "block.minecraft.lapis_ore": "Minério de Lápis-Lazúli",
  "block.minecraft.large_amethyst_bud": "Cristal de Ametista Grande",
  "block.minecraft.large_fern": "Feto Grande",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Caldeirão de Lava",
  "block.minecraft.leaf_litter": "Folhagem",
  "block.minecraft.lectern": "Atril",
  "block.minecraft.lever": "Alavanca",
  "block.minecraft.light": "Luz",
  "block.minecraft.light_blue_banner": "Estandarte Azul-Claro",
  "block.minecraft.light_blue_bed": "Cama Azul-Clara",
  "block.minecraft.light_blue_candle": "Vela Azul-Clara",
  "block.minecraft.light_blue_candle_cake": "Bolo com Vela Azul-Clara",
  "block.minecraft.light_blue_carpet": "Tapete Azul-Claro",
  "block.minecraft.light_blue_concrete": "Betão Azul-Claro",
  "block.minecraft.light_blue_concrete_powder": "Betão Azul-Claro em Pó",
  "block.minecraft.light_blue_glazed_terracotta": "Azulejo Azul-Claro",
  "block.minecraft.light_blue_shulker_box": "Caixa de Shulker Azul-Clara",
  "block.minecraft.light_blue_stained_glass": "Vidro Azul-Claro",
  "block.minecraft.light_blue_stained_glass_pane": "Vidraça Azul-Clara",
  "block.minecraft.light_blue_terracotta": "Terracota Azul-Clara",
  "block.minecraft.light_blue_wool": "Lã Azul-Clara",
  "block.minecraft.light_gray_banner": "Estandarte Cinzento-Claro",
  "block.minecraft.light_gray_bed": "Cama Cinzento-Clara",
  "block.minecraft.light_gray_candle": "Vela Cinzento-Clara",
  "block.minecraft.light_gray_candle_cake": "Bolo com Vela Cinzento-Clara",
  "block.minecraft.light_gray_carpet": "Tapete Cinzento-Claro",
  "block.minecraft.light_gray_concrete": "Betão Cinzento-Claro",
  "block.minecraft.light_gray_concrete_powder": "Betão Cinzento-Claro em Pó",
  "block.minecraft.light_gray_glazed_terracotta": "Azulejo Cinzento-Claro",
  "block.minecraft.light_gray_shulker_box": "Caixa de Shulker Cinzento-Clara",
  "block.minecraft.light_gray_stained_glass": "Vidro Cinzento-Claro",
  "block.minecraft.light_gray_stained_glass_pane": "Vidraça Cinzento-Clara",
  "block.minecraft.light_gray_terracotta": "Terracota Cinzento-Clara",
  "block.minecraft.light_gray_wool": "Lã Cinzento-Clara",
  "block.minecraft.light_weighted_pressure_plate": "Placa de Pressão Medidora Leve",
  "block.minecraft.lightning_rod": "Para-Raios",
  "block.minecraft.lilac": "Lilás",
  "block.minecraft.lily_of_the_valley": "Lírio-do-Vale",
  "block.minecraft.lily_pad": "Nenúfar",
  "block.minecraft.lime_banner": "Estandarte Verde-Lima",
  "block.minecraft.lime_bed": "Cama Verde-Lima",
  "block.minecraft.lime_candle": "Vela Verde-Lima",
  "block.minecraft.lime_candle_cake": "Bolo com Vela Verde-Lima",
  "block.minecraft.lime_carpet": "Tapete Verde-Lima",
  "block.minecraft.lime_concrete": "Betão Verde-Lima",
  "block.minecraft.lime_concrete_powder": "Betão Verde-Lima em Pó",
  "block.minecraft.lime_glazed_terracotta": "Azulejo Verde-Lima",
  "block.minecraft.lime_shulker_box": "Caixa de Shulker Verde-Lima",
  "block.minecraft.lime_stained_glass": "Vidro Verde-Lima",
  "block.minecraft.lime_stained_glass_pane": "Vidraça Verde-Lima",
  "block.minecraft.lime_terracotta": "Terracota Verde-Lima",
  "block.minecraft.lime_wool": "Lã Verde-Lima",
  "block.minecraft.lodestone": "Magnetite",
  "block.minecraft.loom": "Tear",
  "block.minecraft.magenta_banner": "Estandarte Magenta",
  "block.minecraft.magenta_bed": "Cama Magenta",
  "block.minecraft.magenta_candle": "Vela Magenta",
  "block.minecraft.magenta_candle_cake": "Bolo com Vela Magenta",
  "block.minecraft.magenta_carpet": "Tapete Magenta",
  "block.minecraft.magenta_concrete": "Betão Magenta",
  "block.minecraft.magenta_concrete_powder": "Betão Magenta em Pó",
  "block.minecraft.magenta_glazed_terracotta": "Azulejo Magenta",
  "block.minecraft.magenta_shulker_box": "Caixa de Shulker Magenta",
  "block.minecraft.magenta_stained_glass": "Vidro Magenta",
  "block.minecraft.magenta_stained_glass_pane": "Vidraça Magenta",
  "block.minecraft.magenta_terracotta": "Terracota Magenta",
  "block.minecraft.magenta_wool": "Lã Magenta",
  "block.minecraft.magma_block": "Bloco de Magma",
  "block.minecraft.mangrove_button": "Botão de Mangue",
  "block.minecraft.mangrove_door": "Porta de Mangue",
  "block.minecraft.mangrove_fence": "Cerca de Mangue",
  "block.minecraft.mangrove_fence_gate": "Portão de Mangue",
  "block.minecraft.mangrove_hanging_sign": "Tabuleta Pendurada de Mangue",
  "block.minecraft.mangrove_leaves": "Folhas de Mangue",
  "block.minecraft.mangrove_log": "Tronco de Mangue",
  "block.minecraft.mangrove_planks": "Tábuas de Mangue",
  "block.minecraft.mangrove_pressure_plate": "Placa de Pressão de Mangue",
  "block.minecraft.mangrove_propagule": "Propágulo de Mangue",
  "block.minecraft.mangrove_roots": "Raízes de Mangue",
  "block.minecraft.mangrove_shelf": "Estante de Mangue",
  "block.minecraft.mangrove_sign": "Tabuleta de Mangue",
  "block.minecraft.mangrove_slab": "Degrau de Mangue",
  "block.minecraft.mangrove_stairs": "Escadas de Mangue",
  "block.minecraft.mangrove_trapdoor": "Alçapão de Mangue",
  "block.minecraft.mangrove_wall_hanging_sign": "Tabuleta Pendurada de Mangue de Parede",
  "block.minecraft.mangrove_wall_sign": "Tabuleta de Mangue de Parede",
  "block.minecraft.mangrove_wood": "Madeira de Mangue",
  "block.minecraft.medium_amethyst_bud": "Cristal de Ametista Médio",
  "block.minecraft.melon": "Melancia",
  "block.minecraft.melon_stem": "Caule de Melancia",
  "block.minecraft.moss_block": "Bloco de Musgo",
  "block.minecraft.moss_carpet": "Tapete de Musgo",
  "block.minecraft.mossy_cobblestone": "Pedregulho com Musgo",
  "block.minecraft.mossy_cobblestone_slab": "Degrau de Pedregulho com Musgo",
  "block.minecraft.mossy_cobblestone_stairs": "Escadas de Pedregulho com Musgo",
  "block.minecraft.mossy_cobblestone_wall": "Muro de Pedregulho com Musgo",
  "block.minecraft.mossy_stone_brick_slab": "Degrau de Tijolos de Pedra com Musgo",
  "block.minecraft.mossy_stone_brick_stairs": "Escadas de Tijolos de Pedra com Musgo",
  "block.minecraft.mossy_stone_brick_wall": "Muro de Tijolos de Pedra com Musgo",
  "block.minecraft.mossy_stone_bricks": "Tijolos de Pedra com Musgo",
  "block.minecraft.moving_piston": "Pistão em Movimento",
  "block.minecraft.mud": "Barro",
  "block.minecraft.mud_brick_slab": "Degrau de Tijolos de Barro",
  "block.minecraft.mud_brick_stairs": "Escadas de Tijolos de Barro",
  "block.minecraft.mud_brick_wall": "Muro de Tijolos de Barro",
  "block.minecraft.mud_bricks": "Tijolos de Barro",
  "block.minecraft.muddy_mangrove_roots": "Raízes de Mangue Barradas",
  "block.minecraft.mushroom_stem": "Pé de Cogumelo",
  "block.minecraft.mycelium": "Micélio",
  "block.minecraft.nether_brick_fence": "Cerca de Tijolos do Nether",
  "block.minecraft.nether_brick_slab": "Degrau de Tijolos do Nether",
  "block.minecraft.nether_brick_stairs": "Escadas de Tijolos do Nether",
  "block.minecraft.nether_brick_wall": "Muro de Tijolos do Nether",
  "block.minecraft.nether_bricks": "Tijolos do Nether",
  "block.minecraft.nether_gold_ore": "Minério de Ouro do Nether",
  "block.minecraft.nether_portal": "Portal do Nether",
  "block.minecraft.nether_quartz_ore": "Minério de Quartzo do Nether",
  "block.minecraft.nether_sprouts": "Rebentos do Nether",
  "block.minecraft.nether_wart": "Fungo do Nether",
  "block.minecraft.nether_wart_block": "Bloco de Fungos do Nether",
  "block.minecraft.netherite_block": "Bloco de Netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloco Musical",
  "block.minecraft.oak_button": "Botão de Carvalho",
  "block.minecraft.oak_door": "Porta de Carvalho",
  "block.minecraft.oak_fence": "Cerca de Carvalho",
  "block.minecraft.oak_fence_gate": "Portão de Carvalho",
  "block.minecraft.oak_hanging_sign": "Tabuleta Pendurada de Carvalho",
  "block.minecraft.oak_leaves": "Folhas de Carvalho",
  "block.minecraft.oak_log": "Tronco de Carvalho",
  "block.minecraft.oak_planks": "Tábuas de Carvalho",
  "block.minecraft.oak_pressure_plate": "Placa de Pressão de Carvalho",
  "block.minecraft.oak_sapling": "Rebento de Carvalho",
  "block.minecraft.oak_shelf": "Estante de Carvalho",
  "block.minecraft.oak_sign": "Tabuleta de Carvalho",
  "block.minecraft.oak_slab": "Degrau de Carvalho",
  "block.minecraft.oak_stairs": "Escadas de Carvalho",
  "block.minecraft.oak_trapdoor": "Alçapão de Carvalho",
  "block.minecraft.oak_wall_hanging_sign": "Tabuleta Pendurada de Carvalho de Parede",
  "block.minecraft.oak_wall_sign": "Tabuleta de Carvalho de Parede",
  "block.minecraft.oak_wood": "Madeira de Carvalho",
  "block.minecraft.observer": "Observador",
  "block.minecraft.obsidian": "Obsidiana",
  "block.minecraft.ochre_froglight": "Luz-Anfíbia Ocre",
  "block.minecraft.ominous_banner": "Estandarte Sinistro",
  "block.minecraft.open_eyeblossom": "Olheira Aberta",
  "block.minecraft.orange_banner": "Estandarte Laranja",
  "block.minecraft.orange_bed": "Cama Laranja",
  "block.minecraft.orange_candle": "Vela Laranja",
  "block.minecraft.orange_candle_cake": "Bolo com Vela Laranja",
  "block.minecraft.orange_carpet": "Tapete Laranja",
  "block.minecraft.orange_concrete": "Betão Laranja",
  "block.minecraft.orange_concrete_powder": "Betão Laranja em Pó",
  "block.minecraft.orange_glazed_terracotta": "Azulejo Laranja",
  "block.minecraft.orange_shulker_box": "Caixa de Shulker Laranja",
  "block.minecraft.orange_stained_glass": "Vidro Laranja",
  "block.minecraft.orange_stained_glass_pane": "Vidraça Laranja",
  "block.minecraft.orange_terracotta": "Terracota Laranja",
  "block.minecraft.orange_tulip": "Tulipa Laranja",
  "block.minecraft.orange_wool": "Lã Laranja",
  "block.minecraft.oxeye_daisy": "Margarida",
  "block.minecraft.oxidized_chiseled_copper": "Cobre Esculpido Oxidado",
  "block.minecraft.oxidized_copper": "Cobre Oxidado",
  "block.minecraft.oxidized_copper_bars": "Barras de Cobre Oxidado",
  "block.minecraft.oxidized_copper_bulb": "Lâmpada de Cobre Oxidado",
  "block.minecraft.oxidized_copper_chain": "Corrente de Cobre Oxidado",
  "block.minecraft.oxidized_copper_chest": "Baú de Cobre Oxidado",
  "block.minecraft.oxidized_copper_door": "Porta de Cobre Oxidado",
  "block.minecraft.oxidized_copper_golem_statue": "Estátua de Golem de Cobre Oxidado",
  "block.minecraft.oxidized_copper_grate": "Grade de Cobre Oxidado",
  "block.minecraft.oxidized_copper_lantern": "Lanterna de Cobre Oxidado",
  "block.minecraft.oxidized_copper_trapdoor": "Alçapão de Cobre Oxidado",
  "block.minecraft.oxidized_cut_copper": "Cobre Cortado Oxidado",
  "block.minecraft.oxidized_cut_copper_slab": "Degrau de Cobre Cortado Oxidado",
  "block.minecraft.oxidized_cut_copper_stairs": "Escadas de Cobre Cortado Oxidado",
  "block.minecraft.oxidized_lightning_rod": "Para-Raios Oxidado",
  "block.minecraft.packed_ice": "Gelo Compactado",
  "block.minecraft.packed_mud": "Barro Compactado",
  "block.minecraft.pale_hanging_moss": "Musgo Pálido Suspenso",
  "block.minecraft.pale_moss_block": "Bloco de Musgo Pálido",
  "block.minecraft.pale_moss_carpet": "Tapete de Musgo Pálido",
  "block.minecraft.pale_oak_button": "Botão de Carvalho Pálido",
  "block.minecraft.pale_oak_door": "Porta de Carvalho Pálido",
  "block.minecraft.pale_oak_fence": "Cerca de Carvalho Pálido",
  "block.minecraft.pale_oak_fence_gate": "Portão de Carvalho Pálido",
  "block.minecraft.pale_oak_hanging_sign": "Tabuleta Pendurada de Carvalho Pálido",
  "block.minecraft.pale_oak_leaves": "Folhas de Carvalho Pálido",
  "block.minecraft.pale_oak_log": "Tronco de Carvalho Pálido",
  "block.minecraft.pale_oak_planks": "Tábuas de Carvalho Pálido",
  "block.minecraft.pale_oak_pressure_plate": "Placa de Pressão de Carvalho Pálido",
  "block.minecraft.pale_oak_sapling": "Rebento de Carvalho Pálido",
  "block.minecraft.pale_oak_shelf": "Estante de Carvalho Pálido",
  "block.minecraft.pale_oak_sign": "Tabuleta de Carvalho Pálido",
  "block.minecraft.pale_oak_slab": "Degrau de Carvalho Pálido",
  "block.minecraft.pale_oak_stairs": "Escadas de Carvalho Pálido",
  "block.minecraft.pale_oak_trapdoor": "Alçapão de Carvalho Pálido",
  "block.minecraft.pale_oak_wall_hanging_sign": "Tabuleta Pendurada de Carvalho Pálido de Parede",
  "block.minecraft.pale_oak_wall_sign": "Tabuleta de Carvalho Pálido de Parede",
  "block.minecraft.pale_oak_wood": "Madeira de Carvalho Pálido",
  "block.minecraft.pearlescent_froglight": "Luz-Anfíbia Perolada",
  "block.minecraft.peony": "Peónia",
  "block.minecraft.petrified_oak_slab": "Degrau de Carvalho Petrificado",
  "block.minecraft.piglin_head": "Cabeça de Piglin",
  "block.minecraft.piglin_wall_head": "Cabeça de Piglin de Parede",
  "block.minecraft.pink_banner": "Estandarte Rosa",
  "block.minecraft.pink_bed": "Cama Rosa",
  "block.minecraft.pink_candle": "Vela Rosa",
  "block.minecraft.pink_candle_cake": "Bolo com Vela Rosa",
  "block.minecraft.pink_carpet": "Tapete Rosa",
  "block.minecraft.pink_concrete": "Betão Rosa",
  "block.minecraft.pink_concrete_powder": "Betão Rosa em Pó",
  "block.minecraft.pink_glazed_terracotta": "Azulejo Rosa",
  "block.minecraft.pink_petals": "Pétalas Rosas",
  "block.minecraft.pink_shulker_box": "Caixa de Shulker Rosa",
  "block.minecraft.pink_stained_glass": "Vidro Rosa",
  "block.minecraft.pink_stained_glass_pane": "Vidraça Rosa",
  "block.minecraft.pink_terracotta": "Terracota Rosa",
  "block.minecraft.pink_tulip": "Tulipa Rosa",
  "block.minecraft.pink_wool": "Lã Rosa",
  "block.minecraft.piston": "Pistão",
  "block.minecraft.piston_head": "Cabeça de Pistão",
  "block.minecraft.pitcher_crop": "Plantação de Cântara",
  "block.minecraft.pitcher_plant": "Cântara",
  "block.minecraft.player_head": "Cabeça de Jogador",
  "block.minecraft.player_head.named": "Cabeça de %s",
  "block.minecraft.player_wall_head": "Cabeça de Jogador de Parede",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Espeleotema Pontiagudo",
  "block.minecraft.polished_andesite": "Andesito Polido",
  "block.minecraft.polished_andesite_slab": "Degrau de Andesito Polido",
  "block.minecraft.polished_andesite_stairs": "Escadas de Andesito Polido",
  "block.minecraft.polished_basalt": "Basalto Polido",
  "block.minecraft.polished_blackstone": "Negrito Polido",
  "block.minecraft.polished_blackstone_brick_slab": "Degrau de Tijolos de Negrito Polido",
  "block.minecraft.polished_blackstone_brick_stairs": "Escadas de Tijolos de Negrito Polido",
  "block.minecraft.polished_blackstone_brick_wall": "Muro de Tijolos de Negrito Polido",
  "block.minecraft.polished_blackstone_bricks": "Tijolos de Negrito Polido",
  "block.minecraft.polished_blackstone_button": "Botão de Negrito Polido",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa de Pressão de Negrito Polido",
  "block.minecraft.polished_blackstone_slab": "Degrau de Negrito Polido",
  "block.minecraft.polished_blackstone_stairs": "Escadas de Negrito Polido",
  "block.minecraft.polished_blackstone_wall": "Muro de Negrito Polido",
  "block.minecraft.polished_deepslate": "Ardósia Polida",
  "block.minecraft.polished_deepslate_slab": "Degrau de Ardósia Polida",
  "block.minecraft.polished_deepslate_stairs": "Escadas de Ardósia Polida",
  "block.minecraft.polished_deepslate_wall": "Muro de Ardósia Polida",
  "block.minecraft.polished_diorite": "Diorito Polido",
  "block.minecraft.polished_diorite_slab": "Degrau de Diorito Polido",
  "block.minecraft.polished_diorite_stairs": "Escadas de Diorito Polido",
  "block.minecraft.polished_granite": "Granito Polido",
  "block.minecraft.polished_granite_slab": "Degrau de Granito Polido",
  "block.minecraft.polished_granite_stairs": "Escadas de Granito Polido",
  "block.minecraft.polished_tuff": "Tufo Polido",
  "block.minecraft.polished_tuff_slab": "Degrau de Tufo Polido",
  "block.minecraft.polished_tuff_stairs": "Escadas de Tufo Polido",
  "block.minecraft.polished_tuff_wall": "Muro de Tufo Polido",
  "block.minecraft.poppy": "Papoila",
  "block.minecraft.potatoes": "Batatas",
  "block.minecraft.potted_acacia_sapling": "Rebento de Acácia num Vaso",
  "block.minecraft.potted_allium": "Alho-Porro num Vaso",
  "block.minecraft.potted_azalea_bush": "Azálea num Vaso",
  "block.minecraft.potted_azure_bluet": "Jasmim num Vaso",
  "block.minecraft.potted_bamboo": "Bambu num Vaso",
  "block.minecraft.potted_birch_sapling": "Rebento de Bétula num Vaso",
  "block.minecraft.potted_blue_orchid": "Orquídea Azul num Vaso",
  "block.minecraft.potted_brown_mushroom": "Cogumelo Castanho num Vaso",
  "block.minecraft.potted_cactus": "Cato num Vaso",
  "block.minecraft.potted_cherry_sapling": "Rebento de Cerejeira num Vaso",
  "block.minecraft.potted_closed_eyeblossom": "Olheira Fechada num Vaso",
  "block.minecraft.potted_cornflower": "Centáurea num Vaso",
  "block.minecraft.potted_crimson_fungus": "Fungo Carmesim num Vaso",
  "block.minecraft.potted_crimson_roots": "Raízes Carmesins num Vaso",
  "block.minecraft.potted_dandelion": "Dente-de-Leão num Vaso",
  "block.minecraft.potted_dark_oak_sapling": "Rebento de Carvalho Escuro num Vaso",
  "block.minecraft.potted_dead_bush": "Arbusto Morto num Vaso",
  "block.minecraft.potted_fern": "Feto num Vaso",
  "block.minecraft.potted_flowering_azalea_bush": "Azálea Florida num Vaso",
  "block.minecraft.potted_golden_dandelion": "Dente-de-Leão Dourado num Vaso",
  "block.minecraft.potted_jungle_sapling": "Rebento da Selva num Vaso",
  "block.minecraft.potted_lily_of_the_valley": "Lírio-do-Vale num Vaso",
  "block.minecraft.potted_mangrove_propagule": "Propágulo de Mangue num Vaso",
  "block.minecraft.potted_oak_sapling": "Rebento de Carvalho num Vaso",
  "block.minecraft.potted_open_eyeblossom": "Olheira Aberta num Vaso",
  "block.minecraft.potted_orange_tulip": "Tulipa Laranja num Vaso",
  "block.minecraft.potted_oxeye_daisy": "Margarida num Vaso",
  "block.minecraft.potted_pale_oak_sapling": "Rebento de Carvalho Pálido num Vaso",
  "block.minecraft.potted_pink_tulip": "Tulipa Rosa num Vaso",
  "block.minecraft.potted_poppy": "Papoila num Vaso",
  "block.minecraft.potted_red_mushroom": "Cogumelo Vermelho num Vaso",
  "block.minecraft.potted_red_tulip": "Tulipa Vermelha num Vaso",
  "block.minecraft.potted_spruce_sapling": "Rebento de Pícea num Vaso",
  "block.minecraft.potted_torchflower": "Fagulheira num Vaso",
  "block.minecraft.potted_warped_fungus": "Fungo Deformado num Vaso",
  "block.minecraft.potted_warped_roots": "Raízes Deformadas num Vaso",
  "block.minecraft.potted_white_tulip": "Tulipa Branca num Vaso",
  "block.minecraft.potted_wither_rose": "Rosa do Wither num Vaso",
  "block.minecraft.powder_snow": "Neve em Pó",
  "block.minecraft.powder_snow_cauldron": "Caldeirão de Neve em Pó",
  "block.minecraft.powered_rail": "Carril Elétrico",
  "block.minecraft.prismarine": "Prismarinho",
  "block.minecraft.prismarine_brick_slab": "Degrau de Tijolos de Prismarinho",
  "block.minecraft.prismarine_brick_stairs": "Escadas de Tijolos de Prismarinho",
  "block.minecraft.prismarine_bricks": "Tijolos de Prismarinho",
  "block.minecraft.prismarine_slab": "Degrau de Prismarinho",
  "block.minecraft.prismarine_stairs": "Escadas de Prismarinho",
  "block.minecraft.prismarine_wall": "Muro de Prismarinho",
  "block.minecraft.pumpkin": "Abóbora",
  "block.minecraft.pumpkin_stem": "Caule de Abóbora",
  "block.minecraft.purple_banner": "Estandarte Roxo",
  "block.minecraft.purple_bed": "Cama Roxa",
  "block.minecraft.purple_candle": "Vela Roxa",
  "block.minecraft.purple_candle_cake": "Bolo com Vela Roxa",
  "block.minecraft.purple_carpet": "Tapete Roxo",
  "block.minecraft.purple_concrete": "Betão Roxo",
  "block.minecraft.purple_concrete_powder": "Betão Roxo em Pó",
  "block.minecraft.purple_glazed_terracotta": "Azulejo Roxo",
  "block.minecraft.purple_shulker_box": "Caixa de Shulker Roxa",
  "block.minecraft.purple_stained_glass": "Vidro Roxo",
  "block.minecraft.purple_stained_glass_pane": "Vidraça Roxa",
  "block.minecraft.purple_terracotta": "Terracota Roxa",
  "block.minecraft.purple_wool": "Lã Roxa",
  "block.minecraft.purpur_block": "Bloco de Púrpura",
  "block.minecraft.purpur_pillar": "Pilar de Púrpura",
  "block.minecraft.purpur_slab": "Degrau de Púrpura",
  "block.minecraft.purpur_stairs": "Escadas de Púrpura",
  "block.minecraft.quartz_block": "Bloco de Quartzo",
  "block.minecraft.quartz_bricks": "Tijolos de Quartzo",
  "block.minecraft.quartz_pillar": "Pilar de Quartzo",
  "block.minecraft.quartz_slab": "Degrau de Quartzo",
  "block.minecraft.quartz_stairs": "Escadas de Quartzo",
  "block.minecraft.rail": "Carril",
  "block.minecraft.raw_copper_block": "Bloco de Cobre Bruto",
  "block.minecraft.raw_gold_block": "Bloco de Ouro Bruto",
  "block.minecraft.raw_iron_block": "Bloco de Ferro Bruto",
  "block.minecraft.red_banner": "Estandarte Vermelho",
  "block.minecraft.red_bed": "Cama Vermelha",
  "block.minecraft.red_candle": "Vela Vermelha",
  "block.minecraft.red_candle_cake": "Bolo com Vela Vermelha",
  "block.minecraft.red_carpet": "Tapete Vermelho",
  "block.minecraft.red_concrete": "Betão Vermelho",
  "block.minecraft.red_concrete_powder": "Betão Vermelho em Pó",
  "block.minecraft.red_glazed_terracotta": "Azulejo Vermelho",
  "block.minecraft.red_mushroom": "Cogumelo Vermelho",
  "block.minecraft.red_mushroom_block": "Bloco de Cogumelo Vermelho",
  "block.minecraft.red_nether_brick_slab": "Degrau de Tijolos Vermelhos do Nether",
  "block.minecraft.red_nether_brick_stairs": "Escadas de Tijolos Vermelhos do Nether",
  "block.minecraft.red_nether_brick_wall": "Muro de Tijolos Vermelhos do Nether",
  "block.minecraft.red_nether_bricks": "Tijolos Vermelhos do Nether",
  "block.minecraft.red_sand": "Areia Vermelha",
  "block.minecraft.red_sandstone": "Arenito Vermelho",
  "block.minecraft.red_sandstone_slab": "Degrau de Arenito Vermelho",
  "block.minecraft.red_sandstone_stairs": "Escadas de Arenito Vermelho",
  "block.minecraft.red_sandstone_wall": "Muro de Arenito Vermelho",
  "block.minecraft.red_shulker_box": "Caixa de Shulker Vermelha",
  "block.minecraft.red_stained_glass": "Vidro Vermelho",
  "block.minecraft.red_stained_glass_pane": "Vidraça Vermelha",
  "block.minecraft.red_terracotta": "Terracota Vermelha",
  "block.minecraft.red_tulip": "Tulipa Vermelha",
  "block.minecraft.red_wool": "Lã Vermelha",
  "block.minecraft.redstone_block": "Bloco de Redstone",
  "block.minecraft.redstone_lamp": "Lâmpada de Redstone",
  "block.minecraft.redstone_ore": "Minério de Redstone",
  "block.minecraft.redstone_torch": "Tocha de Redstone",
  "block.minecraft.redstone_wall_torch": "Tocha de Redstone de Parede",
  "block.minecraft.redstone_wire": "Fio de Redstone",
  "block.minecraft.reinforced_deepslate": "Ardósia Reforçada",
  "block.minecraft.repeater": "Repetidor de Redstone",
  "block.minecraft.repeating_command_block": "Bloco de Comando Repetitivo",
  "block.minecraft.resin_block": "Bloco de Resina",
  "block.minecraft.resin_brick_slab": "Degrau de Tijolos de Resina",
  "block.minecraft.resin_brick_stairs": "Escadas de Tijolos de Resina",
  "block.minecraft.resin_brick_wall": "Muro de Tijolos de Resina",
  "block.minecraft.resin_bricks": "Tijolos de Resina",
  "block.minecraft.resin_clump": "Torrão de Resina",
  "block.minecraft.respawn_anchor": "Âncora de Renascimento",
  "block.minecraft.rooted_dirt": "Terra Enraizada",
  "block.minecraft.rose_bush": "Roseira",
  "block.minecraft.sand": "Areia",
  "block.minecraft.sandstone": "Arenito",
  "block.minecraft.sandstone_slab": "Degrau de Arenito",
  "block.minecraft.sandstone_stairs": "Escadas de Arenito",
  "block.minecraft.sandstone_wall": "Muro de Arenito",
  "block.minecraft.scaffolding": "Andaime",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalisador de Sculk",
  "block.minecraft.sculk_sensor": "Sensor de Sculk",
  "block.minecraft.sculk_shrieker": "Alarme de Sculk",
  "block.minecraft.sculk_vein": "Veia de Sculk",
  "block.minecraft.sea_lantern": "Lanterna Marinha",
  "block.minecraft.sea_pickle": "Pepino-do-Mar",
  "block.minecraft.seagrass": "Erva Marinha",
  "block.minecraft.set_spawn": "Local de renascimento definido",
  "block.minecraft.short_dry_grass": "Relva Seca Baixa",
  "block.minecraft.short_grass": "Relva Baixa",
  "block.minecraft.shroomlight": "Cogumelo Luminoso",
  "block.minecraft.shulker_box": "Caixa de Shulker",
  "block.minecraft.skeleton_skull": "Crânio de Esqueleto",
  "block.minecraft.skeleton_wall_skull": "Crânio de Esqueleto de Parede",
  "block.minecraft.slime_block": "Bloco de Slime",
  "block.minecraft.small_amethyst_bud": "Cristal de Ametista Pequeno",
  "block.minecraft.small_dripleaf": "Planta-Goteira Pequena",
  "block.minecraft.smithing_table": "Mesa de Ferraria",
  "block.minecraft.smoker": "Defumador",
  "block.minecraft.smooth_basalt": "Basalto Liso",
  "block.minecraft.smooth_quartz": "Bloco de Quartzo Liso",
  "block.minecraft.smooth_quartz_slab": "Degrau de Quartzo Liso",
  "block.minecraft.smooth_quartz_stairs": "Escadas de Quartzo Liso",
  "block.minecraft.smooth_red_sandstone": "Arenito Vermelho Liso",
  "block.minecraft.smooth_red_sandstone_slab": "Degrau de Arenito Vermelho Liso",
  "block.minecraft.smooth_red_sandstone_stairs": "Escadas de Arenito Vermelho Liso",
  "block.minecraft.smooth_sandstone": "Arenito Liso",
  "block.minecraft.smooth_sandstone_slab": "Degrau de Arenito Liso",
  "block.minecraft.smooth_sandstone_stairs": "Escadas de Arenito Liso",
  "block.minecraft.smooth_stone": "Pedra Lisa",
  "block.minecraft.smooth_stone_slab": "Degrau de Pedra Lisa",
  "block.minecraft.sniffer_egg": "Ovo de Farejador",
  "block.minecraft.snow": "Neve",
  "block.minecraft.snow_block": "Bloco de Neve",
  "block.minecraft.soul_campfire": "Fogueira das Almas",
  "block.minecraft.soul_fire": "Fogo das Almas",
  "block.minecraft.soul_lantern": "Lanterna das Almas",
  "block.minecraft.soul_sand": "Areia das Almas",
  "block.minecraft.soul_soil": "Terra das Almas",
  "block.minecraft.soul_torch": "Tocha das Almas",
  "block.minecraft.soul_wall_torch": "Tocha das Almas de Parede",
  "block.minecraft.spawn.not_valid": "Não tens cama ou âncora de renascimento carregada, ou estão obstruídas",
  "block.minecraft.spawner": "Gerador de Criaturas",
  "block.minecraft.spawner.desc1": "Interage com ovos de invocação:",
  "block.minecraft.spawner.desc2": "Define o tipo de criatura",
  "block.minecraft.sponge": "Esponja",
  "block.minecraft.spore_blossom": "Flor de Esporos",
  "block.minecraft.spruce_button": "Botão de Abeto",
  "block.minecraft.spruce_door": "Porta de Abeto",
  "block.minecraft.spruce_fence": "Cerca de Abeto",
  "block.minecraft.spruce_fence_gate": "Portão de Abeto",
  "block.minecraft.spruce_hanging_sign": "Tabuleta Pendurada de Abeto",
  "block.minecraft.spruce_leaves": "Folhas de Abeto",
  "block.minecraft.spruce_log": "Tronco de Abeto",
  "block.minecraft.spruce_planks": "Tábuas de Abeto",
  "block.minecraft.spruce_pressure_plate": "Placa de Pressão de Abeto",
  "block.minecraft.spruce_sapling": "Rebento de Abeto",
  "block.minecraft.spruce_shelf": "Estante de Abeto",
  "block.minecraft.spruce_sign": "Tabuleta de Abeto",
  "block.minecraft.spruce_slab": "Degrau de Abeto",
  "block.minecraft.spruce_stairs": "Escadas de Abeto",
  "block.minecraft.spruce_trapdoor": "Alçapão de Abeto",
  "block.minecraft.spruce_wall_hanging_sign": "Tabuleta Pendurada de Abeto de Parede",
  "block.minecraft.spruce_wall_sign": "Tabuleta de Abeto de Parede",
  "block.minecraft.spruce_wood": "Madeira de Abeto",
  "block.minecraft.sticky_piston": "Pistão Adesivo",
  "block.minecraft.stone": "Pedra",
  "block.minecraft.stone_brick_slab": "Degrau de Tijolos de Pedra",
  "block.minecraft.stone_brick_stairs": "Escadas de Tijolos de Pedra",
  "block.minecraft.stone_brick_wall": "Muro de Tijolos de Pedra",
  "block.minecraft.stone_bricks": "Tijolos de Pedra",
  "block.minecraft.stone_button": "Botão de Pedra",
  "block.minecraft.stone_pressure_plate": "Placa de Pressão de Pedra",
  "block.minecraft.stone_slab": "Degrau de Pedra",
  "block.minecraft.stone_stairs": "Escadas de Pedra",
  "block.minecraft.stonecutter": "Cortador de Pedras",
  "block.minecraft.stripped_acacia_log": "Tronco de Acácia Descascado",
  "block.minecraft.stripped_acacia_wood": "Madeira de Acácia Descascada",
  "block.minecraft.stripped_bamboo_block": "Bloco de Bambu Descascado",
  "block.minecraft.stripped_birch_log": "Tronco de Bétula Descascado",
  "block.minecraft.stripped_birch_wood": "Madeira de Bétula Descascada",
  "block.minecraft.stripped_cherry_log": "Tronco de Cerejeira Descascado",
  "block.minecraft.stripped_cherry_wood": "Madeira de Cerejeira Descascada",
  "block.minecraft.stripped_crimson_hyphae": "Hifas Carmesins Descascadas",
  "block.minecraft.stripped_crimson_stem": "Pé Carmesim Descascado",
  "block.minecraft.stripped_dark_oak_log": "Tronco de Carvalho Escuro Descascado",
  "block.minecraft.stripped_dark_oak_wood": "Madeira de Carvalho Escuro Descascada",
  "block.minecraft.stripped_jungle_log": "Tronco da Selva Descascado",
  "block.minecraft.stripped_jungle_wood": "Madeira da Selva Descascada",
  "block.minecraft.stripped_mangrove_log": "Tronco de Mangue Descascado",
  "block.minecraft.stripped_mangrove_wood": "Madeira de Mangue Descascada",
  "block.minecraft.stripped_oak_log": "Tronco de Carvalho Descascado",
  "block.minecraft.stripped_oak_wood": "Madeira de Carvalho Descascada",
  "block.minecraft.stripped_pale_oak_log": "Tronco de Carvalho Pálido Descascado",
  "block.minecraft.stripped_pale_oak_wood": "Madeira de Carvalho Pálido Descascada",
  "block.minecraft.stripped_spruce_log": "Tronco de Abeto Descascado",
  "block.minecraft.stripped_spruce_wood": "Madeira de Abeto Descascada",
  "block.minecraft.stripped_warped_hyphae": "Hifas Deformadas Descascadas",
  "block.minecraft.stripped_warped_stem": "Pé Deformado Descascado",
  "block.minecraft.structure_block": "Bloco de Estrutura",
  "block.minecraft.structure_void": "Vazio Estrutural",
  "block.minecraft.sugar_cane": "Cana-de-Açúcar",
  "block.minecraft.sunflower": "Girassol",
  "block.minecraft.suspicious_gravel": "Gravilha Suspeita",
  "block.minecraft.suspicious_sand": "Areia Suspeita",
  "block.minecraft.sweet_berry_bush": "Arbusto de Bagas Doces",
  "block.minecraft.tall_dry_grass": "Relva Seca Alta",
  "block.minecraft.tall_grass": "Relva Alta",
  "block.minecraft.tall_seagrass": "Erva Marinha Alta",
  "block.minecraft.target": "Alvo",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Bloco de Teste",
  "block.minecraft.test_instance_block": "Bloco de Instância de Teste",
  "block.minecraft.tinted_glass": "Vidro Fosco",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "As explosões de TNT estão desativadas",
  "block.minecraft.torch": "Tocha",
  "block.minecraft.torchflower": "Fagulheira",
  "block.minecraft.torchflower_crop": "Plantação de Fagulheira",
  "block.minecraft.trapped_chest": "Baú Armadilhado",
  "block.minecraft.trial_spawner": "Gerador Reforçado",
  "block.minecraft.tripwire": "Fio Armadilhado",
  "block.minecraft.tripwire_hook": "Gancho de Fio Armadilhado",
  "block.minecraft.tube_coral": "Coral-Tubular",
  "block.minecraft.tube_coral_block": "Bloco de Coral-Tubular",
  "block.minecraft.tube_coral_fan": "Gorgónia-Tubular",
  "block.minecraft.tube_coral_wall_fan": "Gorgónia-Tubular de Parede",
  "block.minecraft.tuff": "Tufo",
  "block.minecraft.tuff_brick_slab": "Degrau de Tijolos de Tufo",
  "block.minecraft.tuff_brick_stairs": "Escadas de Tijolos de Tufo",
  "block.minecraft.tuff_brick_wall": "Muro de Tijolos de Tufo",
  "block.minecraft.tuff_bricks": "Tijolos de Tufo",
  "block.minecraft.tuff_slab": "Degrau de Tufo",
  "block.minecraft.tuff_stairs": "Escadas de Tufo",
  "block.minecraft.tuff_wall": "Muro de Tufo",
  "block.minecraft.turtle_egg": "Ovo de Tartaruga",
  "block.minecraft.twisting_vines": "Trepadeiras Retorcidas",
  "block.minecraft.twisting_vines_plant": "Planta de Trepadeiras Retorcidas",
  "block.minecraft.vault": "Cofre",
  "block.minecraft.verdant_froglight": "Luz-Anfíbia Verdejante",
  "block.minecraft.vine": "Trepadeiras",
  "block.minecraft.void_air": "Ar do Vazio",
  "block.minecraft.wall_torch": "Tocha de Parede",
  "block.minecraft.warped_button": "Botão Deformado",
  "block.minecraft.warped_door": "Porta Deformada",
  "block.minecraft.warped_fence": "Cerca Deformada",
  "block.minecraft.warped_fence_gate": "Portão Deformado",
  "block.minecraft.warped_fungus": "Fungo Deformado",
  "block.minecraft.warped_hanging_sign": "Tabuleta Pendurada Deformada",
  "block.minecraft.warped_hyphae": "Hifas Deformadas",
  "block.minecraft.warped_nylium": "Nicélio Deformado",
  "block.minecraft.warped_planks": "Tábuas Deformadas",
  "block.minecraft.warped_pressure_plate": "Placa de Pressão Deformada",
  "block.minecraft.warped_roots": "Raízes Deformadas",
  "block.minecraft.warped_shelf": "Estante Deformada",
  "block.minecraft.warped_sign": "Tabuleta Deformada",
  "block.minecraft.warped_slab": "Degrau Deformado",
  "block.minecraft.warped_stairs": "Escadas Deformadas",
  "block.minecraft.warped_stem": "Pé Deformado",
  "block.minecraft.warped_trapdoor": "Alçapão Deformado",
  "block.minecraft.warped_wall_hanging_sign": "Tabuleta Pendurada Deformada de Parede",
  "block.minecraft.warped_wall_sign": "Tabuleta Deformada de Parede",
  "block.minecraft.warped_wart_block": "Bloco de Fungos Deformados",
  "block.minecraft.water": "Água",
  "block.minecraft.water_cauldron": "Caldeirão de Água",
  "block.minecraft.waxed_chiseled_copper": "Cobre Esculpido Encerado",
  "block.minecraft.waxed_copper_bars": "Barras de Cobre Encerado",
  "block.minecraft.waxed_copper_block": "Bloco de Cobre Encerado",
  "block.minecraft.waxed_copper_bulb": "Lâmpada de Cobre Encerado",
  "block.minecraft.waxed_copper_chain": "Corrente de Cobre Encerado",
  "block.minecraft.waxed_copper_chest": "Baú de Cobre Encerado",
  "block.minecraft.waxed_copper_door": "Porta de Cobre Encerado",
  "block.minecraft.waxed_copper_golem_statue": "Estátua de Golem de Cobre Encerado",
  "block.minecraft.waxed_copper_grate": "Grade de Cobre Encerado",
  "block.minecraft.waxed_copper_lantern": "Lanterna de Cobre Encerado",
  "block.minecraft.waxed_copper_trapdoor": "Alçapão de Cobre Encerado",
  "block.minecraft.waxed_cut_copper": "Cobre Cortado Encerado",
  "block.minecraft.waxed_cut_copper_slab": "Degrau de Cobre Cortado Encerado",
  "block.minecraft.waxed_cut_copper_stairs": "Escadas de Cobre Cortado Encerado",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cobre Esculpido Exposto Encerado",
  "block.minecraft.waxed_exposed_copper": "Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_bars": "Barras de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_bulb": "Lâmpada de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_chain": "Corrente de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_chest": "Baú de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_door": "Porta de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Estátua de Golem de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_grate": "Grade de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_lantern": "Lanterna de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Alçapão de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_cut_copper": "Cobre Cortado Exposto Encerado",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Degrau de Cobre Cortado Exposto Encerado",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escadas de Cobre Cortado Exposto Encerado",
  "block.minecraft.waxed_exposed_lightning_rod": "Para-Raios Exposto Encerado",
  "block.minecraft.waxed_lightning_rod": "Para-Raios Encerado",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cobre Esculpido Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper": "Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_bars": "Barras de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lâmpada de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_chain": "Corrente de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_chest": "Baú de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_door": "Porta de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Estátua de Golem de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_grate": "Grade de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lanterna de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Alçapão de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_cut_copper": "Cobre Cortado Oxidado Encerado",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Degrau de Cobre Cortado Oxidado Encerado",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escadas de cobre cortado oxidado encerado",
  "block.minecraft.waxed_oxidized_lightning_rod": "Para-Raios Oxidado Encerado",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cobre Esculpido Corroído Encerado",
  "block.minecraft.waxed_weathered_copper": "Cobre Corroído Encerado",
  "block.minecraft.waxed_weathered_copper_bars": "Barras de Cobre Corroído Encerado",
  "block.minecraft.waxed_weathered_copper_bulb": "Lâmpada de Cobre Corroído Encerado",
  "block.minecraft.waxed_weathered_copper_chain": "Corrente de Cobre Corroído Encerado",
  "block.minecraft.waxed_weathered_copper_chest": "Baú de Cobre Corroído Encerado",
  "block.minecraft.waxed_weathered_copper_door": "Porta de Cobre Corroído Encerado",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Estátua de Golem de Cobre Corroído Encerado",
  "block.minecraft.waxed_weathered_copper_grate": "Grade de Cobre Corroído Encerado",
  "block.minecraft.waxed_weathered_copper_lantern": "Lanterna de Cobre Corroído Encerado",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Alçapão de Cobre Corroído Encerado",
  "block.minecraft.waxed_weathered_cut_copper": "Cobre Cortado Corroído Encerado",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Degrau de Cobre Cortado Corroído Encerado",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escadas de Cobre Cortado Corroído Encerado",
  "block.minecraft.waxed_weathered_lightning_rod": "Para-Raios Corroído Encerado",
  "block.minecraft.weathered_chiseled_copper": "Cobre Esculpido Corroído",
  "block.minecraft.weathered_copper": "Cobre Corroído",
  "block.minecraft.weathered_copper_bars": "Barras de Cobre Corroído",
  "block.minecraft.weathered_copper_bulb": "Lâmpada de Cobre Corroído",
  "block.minecraft.weathered_copper_chain": "Corrente de Cobre Corroído",
  "block.minecraft.weathered_copper_chest": "Baú de Cobre Corroído",
  "block.minecraft.weathered_copper_door": "Porta de Cobre Corroído",
  "block.minecraft.weathered_copper_golem_statue": "Estátua de Golem de Cobre Corroído",
  "block.minecraft.weathered_copper_grate": "Grade de Cobre Corroído",
  "block.minecraft.weathered_copper_lantern": "Lanterna de Cobre Corroído",
  "block.minecraft.weathered_copper_trapdoor": "Alçapão de Cobre Corroído",
  "block.minecraft.weathered_cut_copper": "Cobre Cortado Corroído",
  "block.minecraft.weathered_cut_copper_slab": "Degrau de Cobre Cortado Corroído",
  "block.minecraft.weathered_cut_copper_stairs": "Escadas de Cobre Cortado Corroído",
  "block.minecraft.weathered_lightning_rod": "Para-Raios Corroído",
  "block.minecraft.weeping_vines": "Trepadeiras Melancólicas",
  "block.minecraft.weeping_vines_plant": "Planta de Trepadeiras Melancólicas",
  "block.minecraft.wet_sponge": "Esponja Húmida",
  "block.minecraft.wheat": "Plantação de Trigo",
  "block.minecraft.white_banner": "Estandarte Branco",
  "block.minecraft.white_bed": "Cama Branca",
  "block.minecraft.white_candle": "Vela Branca",
  "block.minecraft.white_candle_cake": "Bolo com Vela Branca",
  "block.minecraft.white_carpet": "Tapete Branco",
  "block.minecraft.white_concrete": "Betão Branco",
  "block.minecraft.white_concrete_powder": "Betão Branco em Pó",
  "block.minecraft.white_glazed_terracotta": "Azulejo Branco",
  "block.minecraft.white_shulker_box": "Caixa de Shulker Branca",
  "block.minecraft.white_stained_glass": "Vidro Branco",
  "block.minecraft.white_stained_glass_pane": "Vidraça Branca",
  "block.minecraft.white_terracotta": "Terracota Branca",
  "block.minecraft.white_tulip": "Tulipa Branca",
  "block.minecraft.white_wool": "Lã Branca",
  "block.minecraft.wildflowers": "Flores-Silvestres",
  "block.minecraft.wither_rose": "Rosa do Wither",
  "block.minecraft.wither_skeleton_skull": "Crânio de Esqueleto do Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Crânio de Esqueleto do Wither de Parede",
  "block.minecraft.yellow_banner": "Estandarte Amarelo",
  "block.minecraft.yellow_bed": "Cama Amarela",
  "block.minecraft.yellow_candle": "Vela Amarela",
  "block.minecraft.yellow_candle_cake": "Bolo com Vela Amarela",
  "block.minecraft.yellow_carpet": "Tapete Amarelo",
  "block.minecraft.yellow_concrete": "Betão Amarelo",
  "block.minecraft.yellow_concrete_powder": "Betão Amarelo em Pó",
  "block.minecraft.yellow_glazed_terracotta": "Azulejo Amarelo",
  "block.minecraft.yellow_shulker_box": "Caixa de Shulker Amarela",
  "block.minecraft.yellow_stained_glass": "Vidro Amarelo",
  "block.minecraft.yellow_stained_glass_pane": "Vidraça Amarela",
  "block.minecraft.yellow_terracotta": "Terracota Amarela",
  "block.minecraft.yellow_wool": "Lã Amarela",
  "block.minecraft.zombie_head": "Cabeça de Zombie",
  "block.minecraft.zombie_wall_head": "Cabeça de Zombie de Parede",
  "item.minecraft.acacia_boat": "Barco de Acácia",
  "item.minecraft.acacia_chest_boat": "Barco de Acácia com Baú",
  "item.minecraft.allay_spawn_egg": "Ovo de Invocação de Allay",
  "item.minecraft.amethyst_shard": "Fragmento de Ametista",
  "item.minecraft.angler_pottery_shard": "Fragmento de Cerâmica de Pesca",
  "item.minecraft.angler_pottery_sherd": "Fragmento de Cerâmica de Pesca",
  "item.minecraft.apple": "Maçã",
  "item.minecraft.archer_pottery_shard": "Fragmento de Cerâmica de Arco",
  "item.minecraft.archer_pottery_sherd": "Fragmento de Cerâmica de Arco",
  "item.minecraft.armadillo_scute": "Escama de Tatu",
  "item.minecraft.armadillo_spawn_egg": "Ovo de Invocação de Tatu",
  "item.minecraft.armor_stand": "Suporte de Armaduras",
  "item.minecraft.arms_up_pottery_shard": "Fragmento de Cerâmica de Figura",
  "item.minecraft.arms_up_pottery_sherd": "Fragmento de Cerâmica de Figura",
  "item.minecraft.arrow": "Flecha",
  "item.minecraft.axolotl_bucket": "Axolote num Balde",
  "item.minecraft.axolotl_spawn_egg": "Ovo de Invocação de Axolote",
  "item.minecraft.baked_potato": "Batata Assada",
  "item.minecraft.bamboo_chest_raft": "Jangada de Bambu com Baú",
  "item.minecraft.bamboo_raft": "Jangada de Bambu",
  "item.minecraft.bat_spawn_egg": "Ovo de Invocação de Morcego",
  "item.minecraft.bee_spawn_egg": "Ovo de Invocação de Abelha",
  "item.minecraft.beef": "Bife Cru",
  "item.minecraft.beetroot": "Beterraba",
  "item.minecraft.beetroot_seeds": "Sementes de Beterraba",
  "item.minecraft.beetroot_soup": "Sopa de Beterraba",
  "item.minecraft.birch_boat": "Barco de Bétula",
  "item.minecraft.birch_chest_boat": "Barco de Bétula com Baú",
  "item.minecraft.black_bundle": "Sacola Preta",
  "item.minecraft.black_dye": "Corante Preto",
  "item.minecraft.black_harness": "Arreios Pretos",
  "item.minecraft.blade_pottery_shard": "Fragmento de Cerâmica de Espada",
  "item.minecraft.blade_pottery_sherd": "Fragmento de Cerâmica de Espada",
  "item.minecraft.blaze_powder": "Pó de Blaze",
  "item.minecraft.blaze_rod": "Vara de Blaze",
  "item.minecraft.blaze_spawn_egg": "Ovo de Invocação de Blaze",
  "item.minecraft.blue_bundle": "Sacola Azul",
  "item.minecraft.blue_dye": "Corante Azul",
  "item.minecraft.blue_egg": "Ovo Azul",
  "item.minecraft.blue_harness": "Arreios Azuis",
  "item.minecraft.bogged_spawn_egg": "Ovo de Invocação de Enlameado",
  "item.minecraft.bolt_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Revestimento de Parafuso",
  "item.minecraft.bone": "Osso",
  "item.minecraft.bone_meal": "Farinha de Osso",
  "item.minecraft.book": "Livro",
  "item.minecraft.bordure_indented_banner_pattern": "Figura para Estandarte de Bordadura Dentada",
  "item.minecraft.bow": "Arco",
  "item.minecraft.bowl": "Malga",
  "item.minecraft.bread": "Pão",
  "item.minecraft.breeze_rod": "Vara de Vórtice",
  "item.minecraft.breeze_spawn_egg": "Ovo de Invocação de Vórtice",
  "item.minecraft.brewer_pottery_shard": "Fragmento de Cerâmica de Poção",
  "item.minecraft.brewer_pottery_sherd": "Fragmento de Cerâmica de Poção",
  "item.minecraft.brewing_stand": "Fermentador",
  "item.minecraft.brick": "Tijolo",
  "item.minecraft.brown_bundle": "Sacola Castanha",
  "item.minecraft.brown_dye": "Corante Castanho",
  "item.minecraft.brown_egg": "Ovo Castanho",
  "item.minecraft.brown_harness": "Arreios Castanhos",
  "item.minecraft.brush": "Pincel",
  "item.minecraft.bucket": "Balde",
  "item.minecraft.bundle": "Sacola",
  "item.minecraft.bundle.empty": "Vazia",
  "item.minecraft.bundle.empty.description": "Pode carregar um conjunto de vários itens",
  "item.minecraft.bundle.full": "Cheia",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Fragmento de Cerâmica de Fogo",
  "item.minecraft.burn_pottery_sherd": "Fragmento de Cerâmica de Fogo",
  "item.minecraft.camel_husk_spawn_egg": "Ovo de Invocação de Dromedário-Múmia",
  "item.minecraft.camel_spawn_egg": "Ovo de Invocação de Dromedário",
  "item.minecraft.carrot": "Cenoura",
  "item.minecraft.carrot_on_a_stick": "Cenoura num Pau",
  "item.minecraft.cat_spawn_egg": "Ovo de Invocação de Gato",
  "item.minecraft.cauldron": "Caldeirão",
  "item.minecraft.cave_spider_spawn_egg": "Ovo de Invocação de Aranha Venenosa",
  "item.minecraft.chainmail_boots": "Botas de Malha",
  "item.minecraft.chainmail_chestplate": "Peitoral de Malha",
  "item.minecraft.chainmail_helmet": "Capacete de Malha",
  "item.minecraft.chainmail_leggings": "Perneiras de Malha",
  "item.minecraft.charcoal": "Carvão Vegetal",
  "item.minecraft.cherry_boat": "Barco de Cerejeira",
  "item.minecraft.cherry_chest_boat": "Barco de Cerejeira com Baú",
  "item.minecraft.chest_minecart": "Carrinho de Mina com Baú",
  "item.minecraft.chicken": "Frango Cru",
  "item.minecraft.chicken_spawn_egg": "Ovo de Invocação de Galinha",
  "item.minecraft.chorus_fruit": "Fruta do Coro",
  "item.minecraft.clay_ball": "Bola de Argila",
  "item.minecraft.clock": "Relógio",
  "item.minecraft.coal": "Carvão",
  "item.minecraft.coast_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Revestimento do Litoral",
  "item.minecraft.cocoa_beans": "Sementes de Cacau",
  "item.minecraft.cod": "Bacalhau Cru",
  "item.minecraft.cod_bucket": "Bacalhau num Balde",
  "item.minecraft.cod_spawn_egg": "Ovo de Invocação de Bacalhau",
  "item.minecraft.command_block_minecart": "Carrinho de Mina com Bloco de Comando",
  "item.minecraft.compass": "Bússola",
  "item.minecraft.cooked_beef": "Bife",
  "item.minecraft.cooked_chicken": "Frango Assado",
  "item.minecraft.cooked_cod": "Bacalhau Assado",
  "item.minecraft.cooked_mutton": "Carneiro Assado",
  "item.minecraft.cooked_porkchop": "Costeleta de Porco Assada",
  "item.minecraft.cooked_rabbit": "Coelho Assado",
  "item.minecraft.cooked_salmon": "Salmão Assado",
  "item.minecraft.cookie": "Bolacha",
  "item.minecraft.copper_axe": "Machado de Cobre",
  "item.minecraft.copper_boots": "Botas de Cobre",
  "item.minecraft.copper_chestplate": "Peitoral de Cobre",
  "item.minecraft.copper_golem_spawn_egg": "Ovo de Invocação de Golem de Cobre",
  "item.minecraft.copper_helmet": "Capacete de Cobre",
  "item.minecraft.copper_hoe": "Enxada de Cobre",
  "item.minecraft.copper_horse_armor": "Armadura de Cobre para Cavalo",
  "item.minecraft.copper_ingot": "Lingote de Cobre",
  "item.minecraft.copper_leggings": "Perneiras de Cobre",
  "item.minecraft.copper_nautilus_armor": "Armadura de Cobre para Náutilo",
  "item.minecraft.copper_nugget": "Pepita de Cobre",
  "item.minecraft.copper_pickaxe": "Picareta de Cobre",
  "item.minecraft.copper_shovel": "Pá de Cobre",
  "item.minecraft.copper_spear": "Lança de Cobre",
  "item.minecraft.copper_sword": "Espada de Cobre",
  "item.minecraft.cow_spawn_egg": "Ovo de Invocação de Vaca",
  "item.minecraft.creaking_spawn_egg": "Ovo de Invocação de Rangente",
  "item.minecraft.creeper_banner_pattern": "Padrão para Estandarte",
  "item.minecraft.creeper_banner_pattern.desc": "Figura de Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Figura para Estandarte de Creeper",
  "item.minecraft.creeper_spawn_egg": "Ovo de Invocação de Creeper",
  "item.minecraft.crossbow": "Besta",
  "item.minecraft.crossbow.projectile": "Projétil:",
  "item.minecraft.crossbow.projectile.multiple": "Projétil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projétil: %s",
  "item.minecraft.cyan_bundle": "Sacola Cíano",
  "item.minecraft.cyan_dye": "Corante Cíano",
  "item.minecraft.cyan_harness": "Arreios Cíanos",
  "item.minecraft.danger_pottery_shard": "Fragmento de Cerâmica de Creeper",
  "item.minecraft.danger_pottery_sherd": "Fragmento de Cerâmica de Creeper",
  "item.minecraft.dark_oak_boat": "Barco de Carvalho Escuro",
  "item.minecraft.dark_oak_chest_boat": "Barco de Carvalho Escuro com Baú",
  "item.minecraft.debug_stick": "Pau de Depuração",
  "item.minecraft.debug_stick.empty": "%s não tem propriedades",
  "item.minecraft.debug_stick.select": "selecionou \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" foi alterado para %s",
  "item.minecraft.diamond": "Diamante",
  "item.minecraft.diamond_axe": "Machado de Diamante",
  "item.minecraft.diamond_boots": "Botas de Diamante",
  "item.minecraft.diamond_chestplate": "Peitoral de Diamante",
  "item.minecraft.diamond_helmet": "Capacete de Diamante",
  "item.minecraft.diamond_hoe": "Enxada de Diamante",
  "item.minecraft.diamond_horse_armor": "Armadura de Diamante para Cavalo",
  "item.minecraft.diamond_leggings": "Perneiras de Diamante",
  "item.minecraft.diamond_nautilus_armor": "Armadura de Diamante para Náutilo",
  "item.minecraft.diamond_pickaxe": "Picareta de Diamante",
  "item.minecraft.diamond_shovel": "Pá de Diamante",
  "item.minecraft.diamond_spear": "Lança de Diamante",
  "item.minecraft.diamond_sword": "Espada de Diamante",
  "item.minecraft.disc_fragment_5": "Disco Partido",
  "item.minecraft.disc_fragment_5.desc": "Disco de Música — 5",
  "item.minecraft.dolphin_spawn_egg": "Ovo de Invocação de Golfinho",
  "item.minecraft.donkey_spawn_egg": "Ovo de Invocação de Burro",
  "item.minecraft.dragon_breath": "Hálito do Dragão",
  "item.minecraft.dried_kelp": "Algas Secas",
  "item.minecraft.drowned_spawn_egg": "Ovo de Invocação de Afogado",
  "item.minecraft.dune_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Revestimento de Dunas",
  "item.minecraft.echo_shard": "Fragmento de Eco",
  "item.minecraft.egg": "Ovo",
  "item.minecraft.elder_guardian_spawn_egg": "Ovo de Invocação de Guardião-Mor",
  "item.minecraft.elytra": "Élitros",
  "item.minecraft.emerald": "Esmeralda",
  "item.minecraft.enchanted_book": "Livro Encantado",
  "item.minecraft.enchanted_golden_apple": "Maçã Dourada Encantada",
  "item.minecraft.end_crystal": "Cristal do End",
  "item.minecraft.ender_dragon_spawn_egg": "Ovo de Invocação do Dragão do Ender",
  "item.minecraft.ender_eye": "Olho do Ender",
  "item.minecraft.ender_pearl": "Pérola do Ender",
  "item.minecraft.enderman_spawn_egg": "Ovo de Invocação de Enderman",
  "item.minecraft.endermite_spawn_egg": "Ovo de Invocação de Endermite",
  "item.minecraft.evoker_spawn_egg": "Ovo de Invocação de Invocador",
  "item.minecraft.experience_bottle": "Frasco Encantado",
  "item.minecraft.explorer_pottery_shard": "Fragmento de Cerâmica de Mapa",
  "item.minecraft.explorer_pottery_sherd": "Fragmento de Cerâmica de Mapa",
  "item.minecraft.eye_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Revestimento de Olho",
  "item.minecraft.feather": "Pena",
  "item.minecraft.fermented_spider_eye": "Olho de Aranha Fermentado",
  "item.minecraft.field_masoned_banner_pattern": "Figura para Estandarte de Alvenaria",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Projétil de Fogo",
  "item.minecraft.firework_rocket": "Fogo de Artifício",
  "item.minecraft.firework_rocket.flight": "Duração do voo:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Estrela de Fogo de Artifício",
  "item.minecraft.firework_star.black": "preta",
  "item.minecraft.firework_star.blue": "azul",
  "item.minecraft.firework_star.brown": "castanha",
  "item.minecraft.firework_star.custom_color": "personalizada",
  "item.minecraft.firework_star.cyan": "cíano",
  "item.minecraft.firework_star.fade_to": "Desvanece para",
  "item.minecraft.firework_star.flicker": "cintilante",
  "item.minecraft.firework_star.gray": "cinzento",
  "item.minecraft.firework_star.green": "verde",
  "item.minecraft.firework_star.light_blue": "azul-clara",
  "item.minecraft.firework_star.light_gray": "cinzento-clara",
  "item.minecraft.firework_star.lime": "verde-lima",
  "item.minecraft.firework_star.magenta": "magenta",
  "item.minecraft.firework_star.orange": "laranja",
  "item.minecraft.firework_star.pink": "rosa",
  "item.minecraft.firework_star.purple": "roxa",
  "item.minecraft.firework_star.red": "vermelha",
  "item.minecraft.firework_star.shape": "Forma desconhecida",
  "item.minecraft.firework_star.shape.burst": "Explosão",
  "item.minecraft.firework_star.shape.creeper": "Forma de Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bola Grande",
  "item.minecraft.firework_star.shape.small_ball": "Bola Pequena",
  "item.minecraft.firework_star.shape.star": "Forma de estrela",
  "item.minecraft.firework_star.trail": "rasto",
  "item.minecraft.firework_star.white": "branca",
  "item.minecraft.firework_star.yellow": "amarela",
  "item.minecraft.fishing_rod": "Cana de Pesca",
  "item.minecraft.flint": "Sílex",
  "item.minecraft.flint_and_steel": "Isqueiro",
  "item.minecraft.flow_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Revestimento de Fluxo",
  "item.minecraft.flow_banner_pattern": "Padrão para Estandarte",
  "item.minecraft.flow_banner_pattern.desc": "Espiral",
  "item.minecraft.flow_banner_pattern.new": "Figura para Estandarte de Espiral",
  "item.minecraft.flow_pottery_sherd": "Fragmento de Cerâmica de Espiral",
  "item.minecraft.flower_banner_pattern": "Padrão para Estandarte",
  "item.minecraft.flower_banner_pattern.desc": "Figura de Flor",
  "item.minecraft.flower_banner_pattern.new": "Figura para Estandarte de Flor",
  "item.minecraft.flower_pot": "Vaso",
  "item.minecraft.fox_spawn_egg": "Ovo de Invocação de Raposa",
  "item.minecraft.friend_pottery_shard": "Fragmento de Cerâmica de Amigo",
  "item.minecraft.friend_pottery_sherd": "Fragmento de Cerâmica de Amigo",
  "item.minecraft.frog_spawn_egg": "Ovo de Invocação de Sapo",
  "item.minecraft.furnace_minecart": "Carrinho de Mina com Fornalha",
  "item.minecraft.ghast_spawn_egg": "Ovo de Invocação de Ghast",
  "item.minecraft.ghast_tear": "Lágrima de Ghast",
  "item.minecraft.glass_bottle": "Frasco de Vidro",
  "item.minecraft.glistering_melon_slice": "Fatia de Melancia Reluzente",
  "item.minecraft.globe_banner_pattern": "Padrão para Estandarte",
  "item.minecraft.globe_banner_pattern.desc": "Globo",
  "item.minecraft.globe_banner_pattern.new": "Figura para Estandarte de Globo",
  "item.minecraft.glow_berries": "Bagas Brilhantes",
  "item.minecraft.glow_ink_sac": "Saco de Tinta Brilhante",
  "item.minecraft.glow_item_frame": "Moldura Brilhante",
  "item.minecraft.glow_squid_spawn_egg": "Ovo de Invocação de Lula-Brilhante",
  "item.minecraft.glowstone_dust": "Pó de Pedra Luminosa",
  "item.minecraft.goat_horn": "Chifre de Cabra",
  "item.minecraft.goat_spawn_egg": "Ovo de Invocação de Cabra",
  "item.minecraft.gold_ingot": "Lingote de Ouro",
  "item.minecraft.gold_nugget": "Pepita de Ouro",
  "item.minecraft.golden_apple": "Maçã Dourada",
  "item.minecraft.golden_axe": "Machado de Ouro",
  "item.minecraft.golden_boots": "Botas de Ouro",
  "item.minecraft.golden_carrot": "Cenoura Dourada",
  "item.minecraft.golden_chestplate": "Peitoral de Ouro",
  "item.minecraft.golden_helmet": "Capacete de Ouro",
  "item.minecraft.golden_hoe": "Enxada de Ouro",
  "item.minecraft.golden_horse_armor": "Armadura de Ouro para Cavalo",
  "item.minecraft.golden_leggings": "Perneiras de Ouro",
  "item.minecraft.golden_nautilus_armor": "Armadura de Ouro para Náutilo",
  "item.minecraft.golden_pickaxe": "Picareta de Ouro",
  "item.minecraft.golden_shovel": "Pá de Ouro",
  "item.minecraft.golden_spear": "Lança de Ouro",
  "item.minecraft.golden_sword": "Espada de Ouro",
  "item.minecraft.gray_bundle": "Sacola Cinzenta",
  "item.minecraft.gray_dye": "Corante Cinzento",
  "item.minecraft.gray_harness": "Arreios Cinzentos",
  "item.minecraft.green_bundle": "Sacola Verde",
  "item.minecraft.green_dye": "Corante Verde",
  "item.minecraft.green_harness": "Arreios Verdes",
  "item.minecraft.guardian_spawn_egg": "Ovo de Invocação de Guardião",
  "item.minecraft.gunpowder": "Pólvora",
  "item.minecraft.guster_banner_pattern": "Padrão para Estandarte",
  "item.minecraft.guster_banner_pattern.desc": "Vórtice",
  "item.minecraft.guster_banner_pattern.new": "Figura para Estandarte de Vórtice",
  "item.minecraft.guster_pottery_sherd": "Fragmento de Cerâmica de Vórtice",
  "item.minecraft.happy_ghast_spawn_egg": "Ovo de Invocação de Ghast Feliz",
  "item.minecraft.harness": "Arreios",
  "item.minecraft.heart_of_the_sea": "Coração do Mar",
  "item.minecraft.heart_pottery_shard": "Fragmento de Cerâmica de Coração",
  "item.minecraft.heart_pottery_sherd": "Fragmento de Cerâmica de Coração",
  "item.minecraft.heartbreak_pottery_shard": "Fragmento de Cerâmica de Coração Partido",
  "item.minecraft.heartbreak_pottery_sherd": "Fragmento de Cerâmica de Coração Partido",
  "item.minecraft.hoglin_spawn_egg": "Ovo de Invocação de Hoglin",
  "item.minecraft.honey_bottle": "Frasco de Mel",
  "item.minecraft.honeycomb": "Favo de Mel",
  "item.minecraft.hopper_minecart": "Carrinho de Mina com Funil",
  "item.minecraft.horse_spawn_egg": "Ovo de Invocação de Cavalo",
  "item.minecraft.host_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.host_armor_trim_smithing_template.new": "Revestimento de Hospedeiro",
  "item.minecraft.howl_pottery_shard": "Fragmento de Cerâmica de Lobo",
  "item.minecraft.howl_pottery_sherd": "Fragmento de Cerâmica de Lobo",
  "item.minecraft.husk_spawn_egg": "Ovo de Invocação de Necrótico",
  "item.minecraft.ink_sac": "Saco de Tinta",
  "item.minecraft.iron_axe": "Machado de Ferro",
  "item.minecraft.iron_boots": "Botas de Ferro",
  "item.minecraft.iron_chestplate": "Peitoral de Ferro",
  "item.minecraft.iron_golem_spawn_egg": "Ovo de Invocação de Golem de Ferro",
  "item.minecraft.iron_helmet": "Capacete de Ferro",
  "item.minecraft.iron_hoe": "Enxada de Ferro",
  "item.minecraft.iron_horse_armor": "Armadura de Ferro para Cavalo",
  "item.minecraft.iron_ingot": "Lingote de Ferro",
  "item.minecraft.iron_leggings": "Perneiras de Ferro",
  "item.minecraft.iron_nautilus_armor": "Armadura de Ferro para Náutilo",
  "item.minecraft.iron_nugget": "Pepita de Ferro",
  "item.minecraft.iron_pickaxe": "Picareta de Ferro",
  "item.minecraft.iron_shovel": "Pá de Ferro",
  "item.minecraft.iron_spear": "Lança de Ferro",
  "item.minecraft.iron_sword": "Espada de Ferro",
  "item.minecraft.item_frame": "Moldura",
  "item.minecraft.jungle_boat": "Barco da Selva",
  "item.minecraft.jungle_chest_boat": "Barco da Selva com Baú",
  "item.minecraft.knowledge_book": "Enciclopédia",
  "item.minecraft.lapis_lazuli": "Lápis-Lazúli",
  "item.minecraft.lava_bucket": "Balde de Lava",
  "item.minecraft.lead": "Corda",
  "item.minecraft.leather": "Couro",
  "item.minecraft.leather_boots": "Botas de Couro",
  "item.minecraft.leather_chestplate": "Túnica de Couro",
  "item.minecraft.leather_helmet": "Barrete de Couro",
  "item.minecraft.leather_horse_armor": "Armadura de Couro para Cavalo",
  "item.minecraft.leather_leggings": "Perneiras de Couro",
  "item.minecraft.light_blue_bundle": "Sacola Azul-Clara",
  "item.minecraft.light_blue_dye": "Corante Azul-Claro",
  "item.minecraft.light_blue_harness": "Arreios Azul-Claros",
  "item.minecraft.light_gray_bundle": "Sacola Cinzento-Clara",
  "item.minecraft.light_gray_dye": "Corante Cinzento-Claro",
  "item.minecraft.light_gray_harness": "Arreios Cinzento-Claros",
  "item.minecraft.lime_bundle": "Sacola Verde-Lima",
  "item.minecraft.lime_dye": "Corante Verde-Lima",
  "item.minecraft.lime_harness": "Arreios Verde-Limas",
  "item.minecraft.lingering_potion": "Poção Prolongada",
  "item.minecraft.lingering_potion.effect.awkward": "Poção Prolongada Estranha",
  "item.minecraft.lingering_potion.effect.empty": "Poção Prolongada Não Criável",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Poção Prolongada de Resistência ao Fogo",
  "item.minecraft.lingering_potion.effect.harming": "Poção Prolongada de Dano",
  "item.minecraft.lingering_potion.effect.healing": "Poção Prolongada de Cura",
  "item.minecraft.lingering_potion.effect.infested": "Poção Prolongada de Infestação",
  "item.minecraft.lingering_potion.effect.invisibility": "Poção Prolongada de Invisibilidade",
  "item.minecraft.lingering_potion.effect.leaping": "Poção Prolongada de Salto",
  "item.minecraft.lingering_potion.effect.levitation": "Poção Prolongada de Levitação",
  "item.minecraft.lingering_potion.effect.luck": "Poção Prolongada de Sorte",
  "item.minecraft.lingering_potion.effect.mundane": "Poção Prolongada Vulgar",
  "item.minecraft.lingering_potion.effect.night_vision": "Poção Prolongada de Visão Noturna",
  "item.minecraft.lingering_potion.effect.oozing": "Poção Prolongada de Viscosidade",
  "item.minecraft.lingering_potion.effect.poison": "Poção Prolongada de Veneno",
  "item.minecraft.lingering_potion.effect.regeneration": "Poção Prolongada de Regeneração",
  "item.minecraft.lingering_potion.effect.slow_falling": "Poção Prolongada de Queda Lenta",
  "item.minecraft.lingering_potion.effect.slowness": "Poção Prolongada de Lentidão",
  "item.minecraft.lingering_potion.effect.strength": "Poção Prolongada de Força",
  "item.minecraft.lingering_potion.effect.swiftness": "Poção Prolongada de Agilidade",
  "item.minecraft.lingering_potion.effect.thick": "Poção Prolongada Espessa",
  "item.minecraft.lingering_potion.effect.turtle_master": "Poção Prolongada do Mestre-das-Tartarugas",
  "item.minecraft.lingering_potion.effect.water": "Frasco de Água Prolongado",
  "item.minecraft.lingering_potion.effect.water_breathing": "Poção Prolongada de Respiração Aquática",
  "item.minecraft.lingering_potion.effect.weakness": "Poção Prolongada de Fraqueza",
  "item.minecraft.lingering_potion.effect.weaving": "Poção Prolongada de Tecedura",
  "item.minecraft.lingering_potion.effect.wind_charged": "Poção Prolongada de Lufada",
  "item.minecraft.llama_spawn_egg": "Ovo de Invocação de Lama",
  "item.minecraft.lodestone_compass": "Bússola Magnetizada",
  "item.minecraft.mace": "Maça",
  "item.minecraft.magenta_bundle": "Sacola Magenta",
  "item.minecraft.magenta_dye": "Corante Magenta",
  "item.minecraft.magenta_harness": "Arreios Magentas",
  "item.minecraft.magma_cream": "Creme de Magma",
  "item.minecraft.magma_cube_spawn_egg": "Ovo de Invocação de Cubo de Magma",
  "item.minecraft.mangrove_boat": "Barco de Mangue",
  "item.minecraft.mangrove_chest_boat": "Barco de Mangue com Baú",
  "item.minecraft.map": "Mapa em Branco",
  "item.minecraft.melon_seeds": "Sementes de Melancia",
  "item.minecraft.melon_slice": "Fatia de Melancia",
  "item.minecraft.milk_bucket": "Balde de Leite",
  "item.minecraft.minecart": "Carrinho de Mina",
  "item.minecraft.miner_pottery_shard": "Fragmento de Cerâmica de Picareta",
  "item.minecraft.miner_pottery_sherd": "Fragmento de Cerâmica de Picareta",
  "item.minecraft.mojang_banner_pattern": "Padrão para Estandarte",
  "item.minecraft.mojang_banner_pattern.desc": "Insígnia",
  "item.minecraft.mojang_banner_pattern.new": "Figura para Estandarte de Insígnia",
  "item.minecraft.mooshroom_spawn_egg": "Ovo de Invocação de Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Fragmento de Cerâmica de Vigilante",
  "item.minecraft.mourner_pottery_sherd": "Fragmento de Cerâmica de Vigilante",
  "item.minecraft.mule_spawn_egg": "Ovo de Invocação de Mula",
  "item.minecraft.mushroom_stew": "Estufado de Cogumelos",
  "item.minecraft.music_disc_11": "Disco de Música",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Disco de Música",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Disco de Música",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg — 5",
  "item.minecraft.music_disc_blocks": "Disco de Música",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Disco de Música",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Disco de Música",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Disco de Música",
  "item.minecraft.music_disc_creator.desc": "Lena Raine — Creator",
  "item.minecraft.music_disc_creator_music_box": "Disco de Música",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine — Creator (Caixa de Música)",
  "item.minecraft.music_disc_far": "Disco de Música",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Disco de Música",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Disco de Música",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Disco de Música",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Disco de Música",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine — otherside",
  "item.minecraft.music_disc_pigstep": "Disco de Música",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine — Pigstep",
  "item.minecraft.music_disc_precipice": "Disco de Música",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof — Precipice",
  "item.minecraft.music_disc_relic": "Disco de Música",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof — Relic",
  "item.minecraft.music_disc_stal": "Disco de Música",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Disco de Música",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Disco de Música",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy — Tears",
  "item.minecraft.music_disc_wait": "Disco de Música",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Disco de Música",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Carneiro Cru",
  "item.minecraft.name_tag": "Etiqueta",
  "item.minecraft.nautilus_shell": "Concha de Náutilo",
  "item.minecraft.nautilus_spawn_egg": "Ovo de Invocação de Náutilo",
  "item.minecraft.nether_brick": "Tijolo do Nether",
  "item.minecraft.nether_star": "Estrela do Nether",
  "item.minecraft.nether_wart": "Fungo do Nether",
  "item.minecraft.netherite_axe": "Machado de Netherite",
  "item.minecraft.netherite_boots": "Botas de Netherite",
  "item.minecraft.netherite_chestplate": "Peitoral de Netherite",
  "item.minecraft.netherite_helmet": "Capacete de Netherite",
  "item.minecraft.netherite_hoe": "Enxada de Netherite",
  "item.minecraft.netherite_horse_armor": "Armadura de Netherite para Cavalo",
  "item.minecraft.netherite_ingot": "Lingote de Netherite",
  "item.minecraft.netherite_leggings": "Perneiras de Netherite",
  "item.minecraft.netherite_nautilus_armor": "Armadura de Netherite para Náutilo",
  "item.minecraft.netherite_pickaxe": "Picareta de Netherite",
  "item.minecraft.netherite_scrap": "Fragmentos de Netherite",
  "item.minecraft.netherite_shovel": "Pá de Netherite",
  "item.minecraft.netherite_spear": "Lança de Netherite",
  "item.minecraft.netherite_sword": "Espada de Netherite",
  "item.minecraft.netherite_upgrade_smithing_template": "Molde de Ferraria",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Melhoria de Netherite",
  "item.minecraft.oak_boat": "Barco de Carvalho",
  "item.minecraft.oak_chest_boat": "Barco de Carvalho com Baú",
  "item.minecraft.ocelot_spawn_egg": "Ovo de Invocação de Ocelote",
  "item.minecraft.ominous_bottle": "Frasco Sombrio",
  "item.minecraft.ominous_trial_key": "Chave de Desafio Sombria",
  "item.minecraft.orange_bundle": "Sacola Laranja",
  "item.minecraft.orange_dye": "Corante Laranja",
  "item.minecraft.orange_harness": "Arreios Laranjas",
  "item.minecraft.painting": "Quadro",
  "item.minecraft.pale_oak_boat": "Barco de Carvalho Pálido",
  "item.minecraft.pale_oak_chest_boat": "Barco de Carvalho Pálido com Baú",
  "item.minecraft.panda_spawn_egg": "Ovo de Invocação de Panda",
  "item.minecraft.paper": "Papel",
  "item.minecraft.parched_spawn_egg": "Ovo de Invocação de Esqueleto-Múmia",
  "item.minecraft.parrot_spawn_egg": "Ovo de Invocação de Papagaio",
  "item.minecraft.phantom_membrane": "Membrana de Espetro",
  "item.minecraft.phantom_spawn_egg": "Ovo de Invocação de Espetro",
  "item.minecraft.pig_spawn_egg": "Ovo de Invocação de Porco",
  "item.minecraft.piglin_banner_pattern": "Padrão para Estandarte",
  "item.minecraft.piglin_banner_pattern.desc": "Focinho",
  "item.minecraft.piglin_banner_pattern.new": "Figura para Estandarte de Focinho",
  "item.minecraft.piglin_brute_spawn_egg": "Ovo de Invocação de Piglin Bruto",
  "item.minecraft.piglin_spawn_egg": "Ovo de Invocação de Piglin",
  "item.minecraft.pillager_spawn_egg": "Ovo de Invocação de Saqueador",
  "item.minecraft.pink_bundle": "Sacola Rosa",
  "item.minecraft.pink_dye": "Corante Rosa",
  "item.minecraft.pink_harness": "Arreios Rosas",
  "item.minecraft.pitcher_plant": "Cântara",
  "item.minecraft.pitcher_pod": "Vagem de Cântara",
  "item.minecraft.plenty_pottery_shard": "Fragmento de Cerâmica de Baú",
  "item.minecraft.plenty_pottery_sherd": "Fragmento de Cerâmica de Baú",
  "item.minecraft.poisonous_potato": "Batata Venenosa",
  "item.minecraft.polar_bear_spawn_egg": "Ovo de Invocação de Urso-Polar",
  "item.minecraft.popped_chorus_fruit": "Fruta do Coro Cozinhada",
  "item.minecraft.porkchop": "Costeleta de Porco Crua",
  "item.minecraft.potato": "Batata",
  "item.minecraft.potion": "Poção",
  "item.minecraft.potion.effect.awkward": "Poção Estranha",
  "item.minecraft.potion.effect.empty": "Poção Não Criável",
  "item.minecraft.potion.effect.fire_resistance": "Poção de Resistência ao Fogo",
  "item.minecraft.potion.effect.harming": "Poção de Dano",
  "item.minecraft.potion.effect.healing": "Poção de Cura",
  "item.minecraft.potion.effect.infested": "Poção de Infestação",
  "item.minecraft.potion.effect.invisibility": "Poção de Invisibilidade",
  "item.minecraft.potion.effect.leaping": "Poção de Salto",
  "item.minecraft.potion.effect.levitation": "Poção de Levitação",
  "item.minecraft.potion.effect.luck": "Poção de Sorte",
  "item.minecraft.potion.effect.mundane": "Poção Vulgar",
  "item.minecraft.potion.effect.night_vision": "Poção de Visão Noturna",
  "item.minecraft.potion.effect.oozing": "Poção de Viscosidade",
  "item.minecraft.potion.effect.poison": "Poção de Veneno",
  "item.minecraft.potion.effect.regeneration": "Poção de Regeneração",
  "item.minecraft.potion.effect.slow_falling": "Poção de Queda Lenta",
  "item.minecraft.potion.effect.slowness": "Poção de Lentidão",
  "item.minecraft.potion.effect.strength": "Poção de Força",
  "item.minecraft.potion.effect.swiftness": "Poção de Agilidade",
  "item.minecraft.potion.effect.thick": "Poção Espessa",
  "item.minecraft.potion.effect.turtle_master": "Poção do Mestre-das-Tartarugas",
  "item.minecraft.potion.effect.water": "Frasco de Água",
  "item.minecraft.potion.effect.water_breathing": "Poção de Respiração Aquática",
  "item.minecraft.potion.effect.weakness": "Poção de Fraqueza",
  "item.minecraft.potion.effect.weaving": "Poção de Tecedura",
  "item.minecraft.potion.effect.wind_charged": "Poção de Lufada",
  "item.minecraft.pottery_shard_archer": "Fragmento de Cerâmica de Arco",
  "item.minecraft.pottery_shard_arms_up": "Fragmento de Cerâmica de Figura",
  "item.minecraft.pottery_shard_prize": "Fragmento de Cerâmica de Joia",
  "item.minecraft.pottery_shard_skull": "Fragmento de Cerâmica de Caveira",
  "item.minecraft.powder_snow_bucket": "Balde de Neve em Pó",
  "item.minecraft.prismarine_crystals": "Cristais de Prismarinho",
  "item.minecraft.prismarine_shard": "Pedaço de Prismarinho",
  "item.minecraft.prize_pottery_shard": "Fragmento de Cerâmica de Joia",
  "item.minecraft.prize_pottery_sherd": "Fragmento de Cerâmica de Joia",
  "item.minecraft.pufferfish": "Peixe-Balão",
  "item.minecraft.pufferfish_bucket": "Peixe-Balão num Balde",
  "item.minecraft.pufferfish_spawn_egg": "Ovo de Invocação de Peixe-Balão",
  "item.minecraft.pumpkin_pie": "Tarte de Abóbora",
  "item.minecraft.pumpkin_seeds": "Sementes de Abóbora",
  "item.minecraft.purple_bundle": "Sacola Roxa",
  "item.minecraft.purple_dye": "Corante Roxo",
  "item.minecraft.purple_harness": "Arreios Roxos",
  "item.minecraft.quartz": "Quartzo do Nether",
  "item.minecraft.rabbit": "Coelho Cru",
  "item.minecraft.rabbit_foot": "Pata de Coelho",
  "item.minecraft.rabbit_hide": "Pele de Coelho",
  "item.minecraft.rabbit_spawn_egg": "Ovo de Invocação de Coelho",
  "item.minecraft.rabbit_stew": "Estufado de Coelho",
  "item.minecraft.raiser_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Revestimento de Criador",
  "item.minecraft.ravager_spawn_egg": "Ovo de Invocação de Devastador",
  "item.minecraft.raw_copper": "Cobre Bruto",
  "item.minecraft.raw_gold": "Ouro Bruto",
  "item.minecraft.raw_iron": "Ferro Bruto",
  "item.minecraft.recovery_compass": "Bússola de Recuperação",
  "item.minecraft.red_bundle": "Sacola Vermelha",
  "item.minecraft.red_dye": "Corante Vermelho",
  "item.minecraft.red_harness": "Arreios Vermelhos",
  "item.minecraft.redstone": "Pó de Redstone",
  "item.minecraft.resin_brick": "Tijolo de Resina",
  "item.minecraft.resin_clump": "Torrão de Resina",
  "item.minecraft.rib_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Revestimento de Costelas",
  "item.minecraft.rotten_flesh": "Carne Podre",
  "item.minecraft.saddle": "Sela",
  "item.minecraft.salmon": "Salmão Cru",
  "item.minecraft.salmon_bucket": "Salmão num Balde",
  "item.minecraft.salmon_spawn_egg": "Ovo de Invocação de Salmão",
  "item.minecraft.scrape_pottery_sherd": "Fragmento de Cerâmica de Machado",
  "item.minecraft.scute": "Escama",
  "item.minecraft.sentry_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Revestimento de Sentinela",
  "item.minecraft.shaper_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Revestimento de Moldador",
  "item.minecraft.sheaf_pottery_shard": "Fragmento de Cerâmica de Trigo",
  "item.minecraft.sheaf_pottery_sherd": "Fragmento de Cerâmica de Trigo",
  "item.minecraft.shears": "Tesoura",
  "item.minecraft.sheep_spawn_egg": "Ovo de Invocação de Ovelha",
  "item.minecraft.shelter_pottery_shard": "Fragmento de Cerâmica de Árvore",
  "item.minecraft.shelter_pottery_sherd": "Fragmento de Cerâmica de Árvore",
  "item.minecraft.shield": "Escudo",
  "item.minecraft.shield.black": "Escudo Preto",
  "item.minecraft.shield.blue": "Escudo Azul",
  "item.minecraft.shield.brown": "Escudo Castanho",
  "item.minecraft.shield.cyan": "Escudo Cíano",
  "item.minecraft.shield.gray": "Escudo Cinzento",
  "item.minecraft.shield.green": "Escudo Verde",
  "item.minecraft.shield.light_blue": "Escudo Azul-Claro",
  "item.minecraft.shield.light_gray": "Escudo Cinzento-Claro",
  "item.minecraft.shield.lime": "Escudo Verde-Lima",
  "item.minecraft.shield.magenta": "Escudo Magenta",
  "item.minecraft.shield.orange": "Escudo Laranja",
  "item.minecraft.shield.pink": "Escudo Rosa",
  "item.minecraft.shield.purple": "Escudo Roxo",
  "item.minecraft.shield.red": "Escudo Vermelho",
  "item.minecraft.shield.white": "Escudo Branco",
  "item.minecraft.shield.yellow": "Escudo Amarelo",
  "item.minecraft.shulker_shell": "Casca de Shulker",
  "item.minecraft.shulker_spawn_egg": "Ovo de Invocação de Shulker",
  "item.minecraft.sign": "Tabuleta",
  "item.minecraft.silence_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Revestimento de Silêncio",
  "item.minecraft.silverfish_spawn_egg": "Ovo de Invocação de Lepisma",
  "item.minecraft.skeleton_horse_spawn_egg": "Ovo de Invocação de Cavalo-Esqueleto",
  "item.minecraft.skeleton_spawn_egg": "Ovo de Invocação de Esqueleto",
  "item.minecraft.skull_banner_pattern": "Padrão para Estandarte",
  "item.minecraft.skull_banner_pattern.desc": "Figura de Caveira",
  "item.minecraft.skull_banner_pattern.new": "Figura para Estandarte de Caveira",
  "item.minecraft.skull_pottery_shard": "Fragmento de Cerâmica de Caveira",
  "item.minecraft.skull_pottery_sherd": "Fragmento de Cerâmica de Caveira",
  "item.minecraft.slime_ball": "Bola de Slime",
  "item.minecraft.slime_spawn_egg": "Ovo de Invocação de Slime",
  "item.minecraft.smithing_template": "Molde de Ferraria",
  "item.minecraft.smithing_template.applies_to": "Aplicável em:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Adiciona um lingote ou cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Adiciona uma peça de armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingotes e Cristais",
  "item.minecraft.smithing_template.ingredients": "Ingredientes:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Adiciona um Lingote de Netherite",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Equipamento de Diamante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Adiciona uma armadura, arma ou ferramenta de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingote de Netherite",
  "item.minecraft.smithing_template.upgrade": "Melhorias: ",
  "item.minecraft.sniffer_spawn_egg": "Ovo de Invocação de Farejador",
  "item.minecraft.snort_pottery_shard": "Fragmento de Cerâmica de Farejador",
  "item.minecraft.snort_pottery_sherd": "Fragmento de Cerâmica de Farejador",
  "item.minecraft.snout_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Revestimento de Focinho",
  "item.minecraft.snow_golem_spawn_egg": "Ovo de Invocação de Boneco de Neve",
  "item.minecraft.snowball": "Bola de Neve",
  "item.minecraft.spectral_arrow": "Flecha Espectral",
  "item.minecraft.spider_eye": "Olho de Aranha",
  "item.minecraft.spider_spawn_egg": "Ovo de Invocação de Aranha",
  "item.minecraft.spire_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Revestimento de Espiral",
  "item.minecraft.splash_potion": "Poção Arremessável",
  "item.minecraft.splash_potion.effect.awkward": "Poção Arremessável Estranha",
  "item.minecraft.splash_potion.effect.empty": "Poção Arremessável Não Criável",
  "item.minecraft.splash_potion.effect.fire_resistance": "Poção Arremessável de Resistência ao Fogo",
  "item.minecraft.splash_potion.effect.harming": "Poção Arremessável de Dano",
  "item.minecraft.splash_potion.effect.healing": "Poção Arremessável de Cura",
  "item.minecraft.splash_potion.effect.infested": "Poção Arremessável de Infestação",
  "item.minecraft.splash_potion.effect.invisibility": "Poção Arremessável de Invisibilidade",
  "item.minecraft.splash_potion.effect.leaping": "Poção Arremessável de Salto",
  "item.minecraft.splash_potion.effect.levitation": "Poção Arremessável de Levitação",
  "item.minecraft.splash_potion.effect.luck": "Poção Arremessável de Sorte",
  "item.minecraft.splash_potion.effect.mundane": "Poção Arremessável Vulgar",
  "item.minecraft.splash_potion.effect.night_vision": "Poção Arremessável de Visão Noturna",
  "item.minecraft.splash_potion.effect.oozing": "Poção Arremessável de Viscosidade",
  "item.minecraft.splash_potion.effect.poison": "Poção Arremessável de Veneno",
  "item.minecraft.splash_potion.effect.regeneration": "Poção Arremessável de Regeneração",
  "item.minecraft.splash_potion.effect.slow_falling": "Poção Arremessável de Queda Lenta",
  "item.minecraft.splash_potion.effect.slowness": "Poção Arremessável de Lentidão",
  "item.minecraft.splash_potion.effect.strength": "Poção Arremessável de Força",
  "item.minecraft.splash_potion.effect.swiftness": "Poção Arremessável de Agilidade",
  "item.minecraft.splash_potion.effect.thick": "Poção Arremessável Espessa",
  "item.minecraft.splash_potion.effect.turtle_master": "Poção Arremessável do Mestre-das-Tartarugas",
  "item.minecraft.splash_potion.effect.water": "Frasco de Água Arremessável",
  "item.minecraft.splash_potion.effect.water_breathing": "Poção Arremessável de Respiração Aquática",
  "item.minecraft.splash_potion.effect.weakness": "Poção Arremessável de Fraqueza",
  "item.minecraft.splash_potion.effect.weaving": "Poção Arremessável de Tecedura",
  "item.minecraft.splash_potion.effect.wind_charged": "Poção Arremessável de Lufada",
  "item.minecraft.spruce_boat": "Barco de Abeto",
  "item.minecraft.spruce_chest_boat": "Barco de Abeto com Baú",
  "item.minecraft.spyglass": "Telescópio",
  "item.minecraft.squid_spawn_egg": "Ovo de Invocação de Lula",
  "item.minecraft.stick": "Pau",
  "item.minecraft.stone_axe": "Machado de Pedra",
  "item.minecraft.stone_hoe": "Enxada de Pedra",
  "item.minecraft.stone_pickaxe": "Picareta de Pedra",
  "item.minecraft.stone_shovel": "Pá de Pedra",
  "item.minecraft.stone_spear": "Lança de Pedra",
  "item.minecraft.stone_sword": "Espada de Pedra",
  "item.minecraft.stray_spawn_egg": "Ovo de Invocação de Desalmado",
  "item.minecraft.strider_spawn_egg": "Ovo de Invocação de Vagante",
  "item.minecraft.string": "Fio",
  "item.minecraft.sugar": "Açúcar",
  "item.minecraft.suspicious_stew": "Estufado Suspeito",
  "item.minecraft.sweet_berries": "Bagas Doces",
  "item.minecraft.tadpole_bucket": "Girino num Balde",
  "item.minecraft.tadpole_spawn_egg": "Ovo de Invocação de Girino",
  "item.minecraft.tide_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Revestimento de Marés",
  "item.minecraft.tipped_arrow": "Flecha com Efeito",
  "item.minecraft.tipped_arrow.effect.awkward": "Flecha com Efeito",
  "item.minecraft.tipped_arrow.effect.empty": "Flecha com Efeito Não Criável",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flecha de Resistência ao Fogo",
  "item.minecraft.tipped_arrow.effect.harming": "Flecha de Dano",
  "item.minecraft.tipped_arrow.effect.healing": "Flecha de Cura",
  "item.minecraft.tipped_arrow.effect.infested": "Flecha de Infestação",
  "item.minecraft.tipped_arrow.effect.invisibility": "Flecha de Invisibilidade",
  "item.minecraft.tipped_arrow.effect.leaping": "Flecha de Salto",
  "item.minecraft.tipped_arrow.effect.levitation": "Flecha de Levitação",
  "item.minecraft.tipped_arrow.effect.luck": "Flecha de Sorte",
  "item.minecraft.tipped_arrow.effect.mundane": "Flecha com Efeito",
  "item.minecraft.tipped_arrow.effect.night_vision": "Flecha de Visão Noturna",
  "item.minecraft.tipped_arrow.effect.oozing": "Flecha de Viscosidade",
  "item.minecraft.tipped_arrow.effect.poison": "Flecha de Veneno",
  "item.minecraft.tipped_arrow.effect.regeneration": "Flecha de Regeneração",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Flecha de Queda Lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Flecha de Lentidão",
  "item.minecraft.tipped_arrow.effect.strength": "Flecha de Força",
  "item.minecraft.tipped_arrow.effect.swiftness": "Flecha de Agilidade",
  "item.minecraft.tipped_arrow.effect.thick": "Flecha com Efeito",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Flecha do Mestre-das-Tartarugas",
  "item.minecraft.tipped_arrow.effect.water": "Flecha sem Efeito",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Flecha de Respiração Aquática",
  "item.minecraft.tipped_arrow.effect.weakness": "Flecha de Fraqueza",
  "item.minecraft.tipped_arrow.effect.weaving": "Flecha de Tecedura",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Flecha de Lufada",
  "item.minecraft.tnt_minecart": "Carrinho de Mina com TNT",
  "item.minecraft.torchflower_seeds": "Sementes de Fagulheira",
  "item.minecraft.totem_of_undying": "Totem da Imortalidade",
  "item.minecraft.trader_llama_spawn_egg": "Ovo de Invocação de Lama de Vendedor",
  "item.minecraft.trial_key": "Chave de Desafio",
  "item.minecraft.trident": "Tridente",
  "item.minecraft.tropical_fish": "Peixe Tropical",
  "item.minecraft.tropical_fish_bucket": "Peixe Tropical num Balde",
  "item.minecraft.tropical_fish_spawn_egg": "Ovo de Invocação de Peixe Tropical",
  "item.minecraft.turtle_helmet": "Carapaça de Tartaruga",
  "item.minecraft.turtle_scute": "Escama de Tartaruga",
  "item.minecraft.turtle_spawn_egg": "Ovo de Invocação de Tartaruga",
  "item.minecraft.vex_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Revestimento de Vex",
  "item.minecraft.vex_spawn_egg": "Ovo de Invocação de Vex",
  "item.minecraft.villager_spawn_egg": "Ovo de Invocação de Aldeão",
  "item.minecraft.vindicator_spawn_egg": "Ovo de Invocação de Vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "Ovo de Invocação de Vendedor Ambulante",
  "item.minecraft.ward_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Revestimento das Profundezas",
  "item.minecraft.warden_spawn_egg": "Ovo de Invocação de Vigilante",
  "item.minecraft.warped_fungus_on_a_stick": "Fungo Deformado num Pau",
  "item.minecraft.water_bucket": "Balde de Água",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Revestimento de Procurador",
  "item.minecraft.wheat": "Trigo",
  "item.minecraft.wheat_seeds": "Sementes de Trigo",
  "item.minecraft.white_bundle": "Sacola Branca",
  "item.minecraft.white_dye": "Corante Branco",
  "item.minecraft.white_harness": "Arreios Brancos",
  "item.minecraft.wild_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Revestimento da Selva",
  "item.minecraft.wind_charge": "Projétil de Vento",
  "item.minecraft.witch_spawn_egg": "Ovo de Invocação de Bruxa",
  "item.minecraft.wither_skeleton_spawn_egg": "Ovo de Invocação de Esqueleto do Wither",
  "item.minecraft.wither_spawn_egg": "Ovo de invocação do Wither",
  "item.minecraft.wolf_armor": "Armadura de Lobo",
  "item.minecraft.wolf_spawn_egg": "Ovo de Invocação de Lobo",
  "item.minecraft.wooden_axe": "Machado de Madeira",
  "item.minecraft.wooden_hoe": "Enxada de Madeira",
  "item.minecraft.wooden_pickaxe": "Picareta de Madeira",
  "item.minecraft.wooden_shovel": "Pá de Madeira",
  "item.minecraft.wooden_spear": "Lança de Madeira",
  "item.minecraft.wooden_sword": "Espada de Madeira",
  "item.minecraft.writable_book": "Livro e Pena",
  "item.minecraft.written_book": "Livro Escrito",
  "item.minecraft.yellow_bundle": "Sacola Amarela",
  "item.minecraft.yellow_dye": "Corante Amarelo",
  "item.minecraft.yellow_harness": "Arreios Amarelos",
  "item.minecraft.zoglin_spawn_egg": "Ovo de Invocação de Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Ovo de Invocação de Cavalo-Zombie",
  "item.minecraft.zombie_nautilus_spawn_egg": "Ovo de Invocação de Náutilo-Zombie",
  "item.minecraft.zombie_spawn_egg": "Ovo de Invocação de Zombie",
  "item.minecraft.zombie_villager_spawn_egg": "Ovo de Invocação de Aldeão Zombie",
  "item.minecraft.zombified_piglin_spawn_egg": "Ovo de Invocação de Piglin-Zombie"
}
export const pt_pt = items; 
